/* Release Theme - v2.0.3 */
const body = document.querySelector('body');
const main = document.querySelector('main');

const windowDynamicEvents = ["scroll", "resize"];

/* DEVICE DETECTOR -- START */
const DeviceDetector = {
  getUserAgent() {
    return navigator.userAgent.toLowerCase();
  },
  isMobile() {
    const ua = this.getUserAgent();
    const mobileRegex = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i;
    return mobileRegex.test(ua) || window.innerWidth <= 750;
  },
  isTablet() {
    const ua = this.getUserAgent();
    const tabletRegex = /ipad|android(?!.*mobile)|tablet|kindle|playbook|silk/i;
    return tabletRegex.test(ua) || (window.innerWidth > 750 && window.innerWidth <= 990 && 'ontouchstart' in window);
  },
  isDesktop() {
    return !this.isMobile() && !this.isTablet();
  },
  isIOS() {
    const ua = this.getUserAgent();
    const iosRegex = /iphone|ipad|ipod/i;
    return iosRegex.test(ua);
  },
};
/* DEVICE DETECTOR -- END */

/* SECTIONS: HEADER GROUP */
const sectionsOfHeaderGroup = Array.from(
  document.querySelectorAll(".shopify-section-group-header-group")
).filter(section => !section.classList.contains("section-header"));
// then add #header element to the end of the array
const headerElement = document.querySelector("#header, #shopify-section-main-password-header");
if (headerElement) {
  sectionsOfHeaderGroup.push(headerElement);
}

let header = document.querySelector(
  "#header, #shopify-section-main-password-header"
);
let announcementBar = document.querySelector(".js-announcement-bar");

let heroBanner = document.querySelector(".hero-banner");

/* SECTION: Header */
const isHeaderSticky = header?.classList.contains('is-sticky');

/* SECTION: Announcement Bars + viewport scroll effects (header classes, Lenis sync) */
const sectionsOfAnnouncementBar = document.querySelectorAll(
  ".section-announcement-bar",
);

const updateVisibleHeightsOfAnnouncementBars = () => {
  if (!sectionsOfAnnouncementBar.length) {
    return;
  }

  const setRootProp = (property, value) => {
    document.documentElement.style.setProperty(property, value);
  };

  const calcSectionHeights = (section) => {
    const rect = section.getBoundingClientRect();

    return {
      height: rect.height,
      visibleHeight: Math.max(
        0,
        Math.min(
          section.offsetHeight,
          window.innerHeight - rect.top,
          rect.bottom,
        ),
      ),
    };
  };

  let totalVisibleHeights = 0;
  let totalHeights = 0;

  sectionsOfAnnouncementBar.forEach((section) => {
    const { height, visibleHeight } = calcSectionHeights(section);

    totalHeights += height;
    totalVisibleHeights += visibleHeight;
  });

  setRootProp(
    "--announcement-bars-before-header-heights",
    `${parseFloat(totalHeights)}px`,
  );
  setRootProp(
    "--announcement-bars-before-header-visible-heights",
    `${parseFloat(totalVisibleHeights)}px`,
  );
};

if (sectionsOfAnnouncementBar.length) {
  updateVisibleHeightsOfAnnouncementBars();
}

/* PAGE: Collection */
/*
const pageCollection = document.querySelector('body.template--collection');
if (pageCollection) {
  const productGrid = pageCollection.querySelector('.collection-grid-container__products');
  const products = productGrid?.querySelectorAll('.product-card');

  // get .product-card__content height and set max of them as .product-card__content height
  if (products) {
    let maxProductCardContentHeight = 0;
    products.forEach(product => {
      const productCardContent = product.querySelector('.product-card__content');
      if (productCardContent) {
        productCardContent.style.height = 'auto';
        maxProductCardContentHeight = Math.max(maxProductCardContentHeight, productCardContent.offsetHeight);
      }
    });
    products.forEach(product => {
      const productCardContent = product.querySelector('.product-card__content');
      if (productCardContent) {
        productCardContent.style.height = `${maxProductCardContentHeight}px`;
      }
    });
  }
}
  */

let productMedia = document.querySelector(".main-product__media"); // on pdp
let productMediaSwiper = document.querySelector(
  ".main-product__media .swiper--product-gallery"
); // on pdp

let productCardMedia = document.querySelector(".product-card__media");
let productCardCollections = document.querySelector(".product-card");

document.addEventListener("DOMContentLoaded", function () {
  const lazyImages = document.querySelectorAll('img[loading="lazy"]:not(.animation-none)');

  lazyImages.forEach(img => {
    // add initial lazy class
    img.classList.add("lazy");
    img.addEventListener("load", function () {
      handleLazyLoadedImage(img);
    });
    if (img.complete) {
      handleLazyLoadedImage(img);
    }
  });

  function handleLazyLoadedImage(img) {
    if (!img || !img.hasAttribute("loading")) { return; }
    setTimeout(() => {
      img.removeAttribute("loading");
      // remove lazy class after transition
      img.classList.remove("lazy");
    }, 100);
  }

  // Set observer to catch dynamicly added images with lazy loading
  function mutationCallbackForLazyLoadedImage(mutationList, observer) {
    for (const mutation of mutationList) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (node instanceof HTMLElement) {
            if (node.querySelector('img[loading="lazy"]')) {
              node.querySelectorAll('img[loading="lazy"]').forEach(img => {
                handleLazyLoadedImage(img);
              })
            }
          }
        })
      }
    }
  };

  const observer = new MutationObserver(mutationCallbackForLazyLoadedImage);
  observer.observe(
    document.querySelector("body"),
    { childList: true, subtree: true }
  );
  // observer.disconnect();

});

// add loading lazy attribute to div.hero__inner > div.media > video > img
document
  .querySelectorAll(".hero__inner > .media > video > img")
  .forEach(function (el) {
    el.setAttribute("loading", "lazy");
    el.setAttribute("alt", "Video Cover");
  });

// catch all images with class 'lazyload' and add loading lazy attribute
document.querySelectorAll(".lazyload").forEach(function (el) {
  el.setAttribute("loading", "lazy");
});

/* --------------- *** Root Custom Properties — rAF-batched scroll/resize *** --------------- */

let _rootPropsRafId = null;

/**
 * Coalesces scroll/resize into a single rAF frame
 * to avoid layout thrashing on the hot scroll path.
 */
const scheduleRootCustomProperties = () => {
  if (_rootPropsRafId) return;

  _rootPropsRafId = requestAnimationFrame(() => {
    _rootPropsRafId = null;
    setRootCustomProperties();
  });
};

window.addEventListener("scroll", scheduleRootCustomProperties, { passive: true });
window.addEventListener("resize", scheduleRootCustomProperties, { passive: true });

setRootCustomProperties();

if (Shopify.designMode) {
  window.addEventListener("shopify:section:select", setRootCustomProperties);
}

window.addEventListener("shopify:section:load", function () {
  header = document.querySelector(
    "#header, #shopify-section-main-password-header header"
  );
  announcementBar = document.querySelector(".js-announcement-bar");
  productCardMedia = document.querySelector(".product-card__media");
  heroBanner = document.querySelector(".hero-banner");
  hero =
    document.querySelector(".hero-banner") ||
    document.querySelector("main section");
  setRootCustomProperties();
});

function getCoordinates(element) {
  const rect = element.getBoundingClientRect();
  return {
    top: rect.top + window.scrollY,
    right: rect.right + window.scrollX,
    bottom: rect.bottom + window.scrollY,
    left: rect.left + window.scrollX
  };
}

function setCustomProperty(property, value) {
  document.documentElement.style.setProperty(property, value);
}

function setRootCustomProperties() {

  const setCustomProperty = (property, value) => {
    document.documentElement.style.setProperty(property, value);
  };

  // sections of header group - height
  if (sectionsOfHeaderGroup.length > 0) {
    const totalHeight = Array.from(sectionsOfHeaderGroup).reduce((sum, section) => {
      return sum + section.offsetHeight;
    }, 0);
    document.documentElement.style.setProperty('--header-group-height', `${totalHeight - 1}px`);
  }

  // header height
  let headerHeight = 0;
  if (header && isHeaderSticky) {
    headerHeight = header.getBoundingClientRect().height.toFixed(2);
  }
  setCustomProperty("--header-height", `${parseFloat(headerHeight)}px`);

  let cartDrawerBody = document.querySelector(".cart-drawer__body");
  if (cartDrawerBody) {
    setCustomProperty("--cart-drawer-body-width", `${parseFloat(cartDrawerBody.offsetWidth)}px`);
    setCustomProperty("--cart-drawer-body-height", `${parseFloat(cartDrawerBody.offsetHeight)}px`);
  }

  // product media width
  if (productMedia) {
    setCustomProperty("--product-media-area-width", `${parseFloat(productMedia.offsetWidth)}px`);
  }

  // set initial product media area height - start
  function setInitalProductMediaAreaHeight() {
    if (productMedia && body.classList.contains("template--product")) {
      let initialProductMediaAreaHeight = 0;
      const mainTop = getCoordinates(main).top;
      const productMediaTop = getCoordinates(productMedia).top;
      const productTopbar = document.querySelector('.product__topbar-nav');
      let productTopbarHeight = 0;
      if (productTopbar) productTopbarHeight = productTopbar.offsetHeight;
      initialProductMediaAreaHeight = window.innerHeight - Math.round(mainTop) - 2 * Math.round(productMediaTop - mainTop) + Math.round(productTopbarHeight);

      // check if any section exists before product section
      const productSectionIndex = Array.prototype.indexOf.call(main.children, document.querySelector('main section.main-product'));
      if (productSectionIndex > 0) {
        initialProductMediaAreaHeight = window.innerHeight - Math.round(mainTop) - 2 * Math.round(productMediaTop - mainTop) + Math.round(productTopbarHeight);
      }

      initialProductMediaAreaHeight = Math.round(initialProductMediaAreaHeight - 24);

      // set initial product media area height
      setCustomProperty("--product-media-area-height", initialProductMediaAreaHeight + "px");
    }
  }
  function setInitalProductMediaSwiperAreaHeight() {
    const sliderWrapper = document.querySelector('.main-product__media--slider-wrapper');
    if (!sliderWrapper) return;
    setCustomProperty(
      "--product-media-area-swiper-height",
      `${parseInt(sliderWrapper.offsetHeight)}px`
    );
  }
  setInitalProductMediaAreaHeight();
  setInitalProductMediaSwiperAreaHeight();
  // set initial product media area height - end

  /* --------------- *** Hero banner position (for marquee floating bar) *** --------------- */

  heroBanner = document.querySelector(".hero-banner");

  if (heroBanner) {
    setCustomProperty("--hero-banner-bottom", `${parseFloat(getCoordinates(heroBanner).bottom)}px`);
  }

  const articleHeroMedia = document.querySelector(".js-article-hero-media");
  const articleContent = document.querySelector(".js-article-content");
  if (articleHeroMedia || articleContent) {
    // set social share sticky position according to article hero media or article content
    let socialShareStickyTop = 0;
    let socialShareStickyStart = 0;
    let headerBottom = parseInt(header.getBoundingClientRect().bottom);
    if (articleHeroMedia) {
      socialShareStickyTop = parseInt(articleHeroMedia.getBoundingClientRect().top);
      socialShareStickyStart = parseInt(articleHeroMedia.getBoundingClientRect().right);
    } else {
      socialShareStickyTop = parseInt(articleContent.getBoundingClientRect().y);
      socialShareStickyStart = parseInt(articleContent.getBoundingClientRect().right);
    }

    if (socialShareStickyTop < (0 + headerBottom)) {
      socialShareStickyTop = headerBottom;
    }

    setCustomProperty(
      "--social-share-sticky-top",
      `${socialShareStickyTop}px`
    );
    setCustomProperty(
      "--social-share-sticky-start",
      `${socialShareStickyStart}px`
    );

  }

  // transparent header menu color
  // get data-header-menu-text-color of first .hero__inner under .hero-banner element
  if (heroBanner) {
    let heroInner = heroBanner.querySelectorAll(".hero__inner");
    if (heroInner.length > 0) {
      let heroInnerFirst = heroInner[0];
      let headerMenuTextColor = heroInnerFirst.getAttribute("data-header-menu-text-color");
      if (headerMenuTextColor) {
        setCustomProperty(
          "--transparent-header-menu-text-color", `${headerMenuTextColor}`
        );
      }
    }
  } else {
    setCustomProperty(
      "--transparent-header-menu-text-color", `var(--color-background)`
    );
  }

  if (productCardMedia) {
    setCustomProperty(
      "--product-card-media-height",
      `${parseInt(productCardMedia.offsetHeight)}px`
    );
  }
}

/* --------------- *** Product Media Area — one-time resize/observer setup *** --------------- */

/**
 * Registers resize + mutation listeners once for PDP media height,
 * rather than re-registering inside setRootCustomProperties on every call.
 */
(function initProductMediaAreaListeners() {
  let _mediaRafId = null;

  const scheduleMediaHeightUpdate = () => {
    if (_mediaRafId) return;

    _mediaRafId = requestAnimationFrame(() => {
      _mediaRafId = null;
      setRootCustomProperties();
    });
  };

  window.addEventListener("resize", scheduleMediaHeightUpdate, { passive: true });

  if (productMedia) {
    const observer = new MutationObserver(scheduleMediaHeightUpdate);
    observer.observe(productMedia, { childList: true, subtree: true });
  }

  if (Shopify.designMode) {
    window.addEventListener("shopify:section:load", scheduleMediaHeightUpdate);
  }
})();

// scroll-position — header is-at-top / is-scrolled (batched with announcement metrics)
const scrollPositionY = () => {
  const SCROLL_OFFSET = 50;
  const y = window.scrollY;

  if (y <= SCROLL_OFFSET) {
    document.body.classList.add("is-at-top");
    document.body.classList.remove("is-scrolled");
  } else {
    document.body.classList.add("is-scrolled");
    document.body.classList.remove("is-at-top");
  }
};

let viewportScrollEffectsRafId = null;
let boundViewportScrollEffects = null;
let viewportScrollSource = null;

const runViewportScrollEffects = () => {
  scrollPositionY();

  if (sectionsOfAnnouncementBar.length) {
    updateVisibleHeightsOfAnnouncementBars();
  }
};

const scheduleViewportScrollEffects = () => {
  if (viewportScrollEffectsRafId !== null) {
    return;
  }

  viewportScrollEffectsRafId = window.requestAnimationFrame(() => {
    viewportScrollEffectsRafId = null;
    runViewportScrollEffects();
  });
};

const detachViewportScrollEffectsListener = () => {
  if (!boundViewportScrollEffects) {
    return;
  }

  if (viewportScrollSource === window) {
    window.removeEventListener("scroll", boundViewportScrollEffects);
  } else if (
    viewportScrollSource &&
    typeof viewportScrollSource.off === "function"
  ) {
    viewportScrollSource.off("scroll", boundViewportScrollEffects);
  }

  boundViewportScrollEffects = null;
  viewportScrollSource = null;
};

const attachViewportScrollEffectsListener = () => {
  detachViewportScrollEffectsListener();

  boundViewportScrollEffects = scheduleViewportScrollEffects;

  const lenisInstance = window.themeLenis?.lenis ?? null;

  if (lenisInstance) {
    lenisInstance.on("scroll", boundViewportScrollEffects);
    viewportScrollSource = lenisInstance;
  } else {
    window.addEventListener("scroll", boundViewportScrollEffects, {
      passive: true,
    });
    viewportScrollSource = window;
  }
};

scrollPositionY();

document.addEventListener("DOMContentLoaded", () => {
  requestAnimationFrame(() => {
    document.body.classList.remove("preload");
  });

  attachViewportScrollEffectsListener();

  window.addEventListener("resize", scheduleViewportScrollEffects, {
    passive: true,
  });

  const desktopMq = window.themeScrollConfig?.desktopMediaQuery;
  const reducedMq = window.themeScrollConfig?.reducedMotionMediaQuery;

  if (typeof desktopMq === "string" && desktopMq.length > 0) {
    window
      .matchMedia(desktopMq)
      .addEventListener("change", attachViewportScrollEffectsListener);
  }

  if (typeof reducedMq === "string" && reducedMq.length > 0) {
    window
      .matchMedia(reducedMq)
      .addEventListener("change", attachViewportScrollEffectsListener);
  }
});


const bodyScroll = {
  lock(container) {
    bodyScrollLock.disableBodyScroll(container);
  },
  unlock(container) {
    bodyScrollLock.enableBodyScroll(container);
  },
  clear() {
    bodyScrollLock.clearAllBodyScrollLocks();
  }
};

const onKeyUpEscape = event => {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus({
    preventScroll: true
  });
};

const getFocusableElements = container => {
  return Array.from(
    container.querySelectorAll(
      'summary, a[href], button:enabled, [tabindex]:not([tabindex^="-"]), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe'
    )
  );
};

document
  .querySelectorAll('[id^="Details-"] summary')
  .forEach(summary => {
    summary.setAttribute("role", "button");
    summary.setAttribute(
      "aria-expanded",
      summary.parentNode.hasAttribute("open")
    );

    if (summary.nextElementSibling.getAttribute("id")) {
      summary.setAttribute(
        "aria-controls",
        summary.nextElementSibling.id
      );
    }

    summary.addEventListener("click", event => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    if (summary.closest("header-drawer")) return;
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
  });

const trapFocusHandlers = {};

const removeTrapFocus = (elementToFocus = null) => {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener(
    "focusout",
    trapFocusHandlers.focusout
  );
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus)
    elementToFocus.focus({
      preventScroll: true
    });
};

const trapFocus = (container, elementToFocus = container) => {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener(
      "keydown",
      trapFocusHandlers.keydown
    );
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
};

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

const deepClone = obj => {
  return JSON.parse(JSON.stringify(obj));
};

const handleize = str => str.replace(/[ /_]/g, "-").toLowerCase();

const decode = str => decodeURIComponent(str).replace(/\+/g, " ");

/**
 * Compensate for scrollbar removal and pause Lenis while a drawer locks the body.
 * Exposed on window so non-bundled drawer scripts (quick-cart-drawer) can reuse them.
 */
const acquireMenuDrawerBodyScrollUi = () => {
  const scrollbarGapPx =
    window.innerWidth - document.documentElement.clientWidth;

  if (scrollbarGapPx > 0) {
    body.style.marginInlineEnd = `${scrollbarGapPx}px`;
  }

  window.themeLenis?.lenis?.stop?.();
};

const releaseMenuDrawerBodyScrollUi = () => {
  body.style.removeProperty("margin-inline-end");
  window.themeLenis?.lenis?.start?.();
};

window.acquireMenuDrawerBodyScrollUi = acquireMenuDrawerBodyScrollUi;
window.releaseMenuDrawerBodyScrollUi = releaseMenuDrawerBodyScrollUi;

const getOffsetTop = element => {
  let offsetTop = 0;

  do {
    if (!isNaN(element.offsetTop)) {
      offsetTop += element.offsetTop;
    }
  } while ((element = element.offsetParent));

  return offsetTop;
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.drawer = this.querySelector(".js-drawer");
    this.btnsCloseDrawer = this.querySelectorAll(
      ".js-btn-close-drawer"
    );
    this.btnsCloseDrawer = [...this.btnsCloseDrawer].filter(
      btnCloseDrawer =>
        this.drawer === btnCloseDrawer.closest(".js-drawer")
    );
    this.elementToFocus =
      this.querySelector(".js-drawer-focus-element") ||
      this.btnsCloseDrawer[0];
    this.toggleButtons = [this.summary, ...this.btnsCloseDrawer];
    this.isParentDrawerOpen = false;
    this.locksMainDocumentScroll = false;
    this.predictiveSearch = this.querySelector("predictive-search");

    this.releaseScrollLockIfOwner = () => {
      if (!this.locksMainDocumentScroll) return;

      releaseMenuDrawerBodyScrollUi();
      this.locksMainDocumentScroll = false;
    };

    this.HeaderDrawer = document.querySelector("header-drawer");

    this.setInitialAccessibilityAttr();

    this.toggleButtons.forEach(toggleButton => {
      toggleButton.addEventListener("click", e => {
        e.preventDefault();

        this.toggleDrawer();
      });
    });

    this.addEventListener("keydown", e => {
      const isEscapeKey = e.key === "Escape";
      const isDrawerOpen =
        this.details.classList.contains("menu-opening");
      const nestedOpenDrawer =
        this.details.querySelector("details[open]");

      if (!isEscapeKey || nestedOpenDrawer || !isDrawerOpen) {
        return;
      }

      if (
        this.predictiveSearch &&
        this.predictiveSearch.input == document.activeElement
      ) {
        return;
      }

      this.toggleDrawer();
    });

    this.toggleTrapFocus();
  }

  toggleDrawer() {
    const isDetailsOpen = this.details.hasAttribute("open");
    const headerEl = document.getElementById("header");

    if (!isDetailsOpen) {
      this.details.setAttribute("open", "");
      this.toggleButtons.forEach(toggleButton => {
        toggleButton.classList.add("menu-is-open");
        toggleButton.setAttribute("aria-expanded", true);
      });
      this.details.classList.add("menu-opening");
      headerEl?.classList.add("menu-open");

      const bodyHasOverflow = body.style.overflow === "hidden";

      if (bodyHasOverflow) {
        this.parentDrawer = this.closest(".js-drawer");

        if (this.parentDrawer) {
          this.isParentDrawerOpen = true;
        }

        this.locksMainDocumentScroll = false;
      } else {
        body.style.overflow = "hidden";
        body.classList.add("drawer--is-open");
        body.style.width = "100%";
        acquireMenuDrawerBodyScrollUi();
        this.locksMainDocumentScroll = true;
      }

      const searchInput = this.querySelector("#search-desktop");

      if (searchInput) {
        searchInput.focus();
        headerEl?.classList.remove("menu-open");
      }
    } else {
      this.details.classList.remove("menu-opening");
      this.toggleButtons.forEach(toggleButton => {
        toggleButton.classList.remove("menu-is-open");
        toggleButton.setAttribute("aria-expanded", false);
      });

      const navDrawerHeader = headerEl?.querySelector(
        "#Navigation-drawer-header"
      );

      if (navDrawerHeader?.classList.contains("menu-opening")) {
        body.style.overflow = "hidden";
      } else {
        body.style.overflow = "";
        body.style.top = "";
        body.style.width = "";
        body.classList.remove("drawer--is-open");
        this.releaseScrollLockIfOwner();
      }

      if (this.isParentDrawerOpen) {
        this.parentDrawer.style.overflow = "";
      }
      // Removing open synchronously causes transition issues.
      setTimeout(() => {
        this.details.removeAttribute("open");
      }, 300);
    }

    const handleDropdownTransition = e => {
      if (
        e.target !== this.drawer ||
        e.propertyName !== "visibility"
      ) {
        return;
      }

      this.details.classList.remove("drawer-transitioning");

      if (this.elementToFocus) {
        this.elementToFocus.focus({
          preventScroll: true
        });
      }

      const isDetailsOpen = this.details.hasAttribute("open");

      if (!isDetailsOpen) {
        this.toggleButtons.forEach(toggleButton => {
          toggleButton.setAttribute("aria-expanded", false);
        });
        this.summary.focus({
          preventScroll: true
        });
      }

      if (this.isParentDrawerOpen) {
        this.parentDrawer.style.overflow = "";
        document.body.style.overflow = "";
      } else {
        document.body.style.overflow = "hidden";
      }

      e.target.removeEventListener(
        "transitionend",
        handleDropdownTransition
      );
    };

    this.drawer.addEventListener(
      "transitionstart",
      e => {
        this.details.classList.add("drawer-transitioning");
      },
      {
        once: true
      }
    );

    this.drawer.addEventListener(
      "transitionend",
      handleDropdownTransition
    );
  }

  /* probably not needed -- start */
  closeAllOtherDrawers() {
    const allDrawers = document.querySelectorAll(".js-drawer");
    allDrawers.forEach(drawer => {
      const details = drawer.closest("details");
      if (details && details !== this.details) {
        details.removeAttribute("open");
        drawer.style.overflow = "";
      }
    });

    document.body.style.overflow = "";
    this.releaseScrollLockIfOwner();
  }
  /* probably not needed -- end */

  instantlyHideDrawer() {
    this.toggleButtons.forEach(toggleButton => {
      toggleButton.setAttribute("aria-expanded", false);
    });
    this.details.classList.remove("menu-opening");
    this.details.removeAttribute("open");
    body.style.overflow = "";
    this.releaseScrollLockIfOwner();
  }

  toggleTrapFocus(container = this.drawer) {
    let isHandlingFocus = false;

    document.addEventListener("focusin", e => {
      if (isHandlingFocus) return;
      isHandlingFocus = true;

      const isDrawerOpen =
        this.details.classList.contains("menu-opening");

      if (!isDrawerOpen) {
        isHandlingFocus = false;
        return;
      }

      const isToggleButton = this.toggleButtons.some(btn =>
        btn === e.target || btn.contains(e.target)
      );

      if (isToggleButton) {
        isHandlingFocus = false;
        return;
      }

      const openDrawer = e.target.closest(
        "details.menu-opening .js-drawer"
      );
      const nestedOpenDrawer = this.details.querySelector(
        "details.menu-opening"
      );

      if (openDrawer === this.drawer || nestedOpenDrawer) {
        isHandlingFocus = false;
        return;
      }

      e.preventDefault();

      const focusableElements = getFocusableElements(container);
      const focusedElementDOMPosition =
        container.compareDocumentPosition(e.target);

      const visibleFocusableElements = focusableElements.filter(
        focusableElement => {
          const isHidden =
            getComputedStyle(focusableElement).display === "none";

          if (isHidden) {
            return;
          }

          const isSummary = focusableElement.tagName === "SUMMARY";
          const focusableElementDetails =
            focusableElement.closest("details");
          const parentFocusableElementDetails =
            focusableElementDetails.parentElement.closest("details");
          const focusableElementDrawer =
            focusableElementDetails.querySelector(".js-drawer");
          const isThisDrawerOrDetails = focusableElementDrawer
            ? focusableElementDrawer === this.drawer
            : focusableElementDetails === this.details;

          return (
            isThisDrawerOrDetails ||
            (isSummary &&
              parentFocusableElementDetails.hasAttribute("open"))
          );
        }
      );

      const firstFocusableElement = visibleFocusableElements[0];
      const lastFocusableElement =
        visibleFocusableElements[visibleFocusableElements.length - 1];

      if (focusedElementDOMPosition >= 4) {
        firstFocusableElement.focus({
          preventScroll: true
        });
      } else {
        lastFocusableElement.focus({
          preventScroll: true
        });
      }
      isHandlingFocus = false;
    });
  }

  setInitialAccessibilityAttr() {
    const isDetailsOpen = this.details.hasAttribute("open");

    this.summary.setAttribute("role", "button");
    this.summary.setAttribute("aria-controls", this.drawer.id);
    this.summary.setAttribute("aria-expanded", isDetailsOpen);
  }
}
customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.resetSlideOutMenuPanels = () => {
      const primaryMenuPanel = this.querySelector(".primary-menu-panel");
      const allPanels = this.querySelectorAll(".menu-panel");

      allPanels.forEach(panel => {
        panel.classList.remove("is-active", "is-back", "non-active", "is-instant");
        panel.style.opacity = "";
        panel.removeAttribute("inert");
      });

      if (primaryMenuPanel) {
        primaryMenuPanel.style.opacity = "";
        primaryMenuPanel.removeAttribute("inert");
        primaryMenuPanel.removeAttribute("aria-hidden");
      }
    };

    window.addEventListener("resize", e => {
      const isMobileDrawer = this.classList.contains("mobile-drawer");
      if (!isMobileDrawer) {
        return;
      }

      const isMenuOpen = this.details.classList.contains("menu-opening");
      if (DeviceDetector.isMobile() || !isMenuOpen) {
        return;
      }

      this.instantlyHideDrawer();
    });
  }

  instantlyHideDrawer() {
    super.instantlyHideDrawer();
  }

  /**
   * Some mobile browsers natively toggle <details> despite preventDefault,
   * causing the open attribute to be out of sync with our managed state.
   * Normalize the attribute before calling super so the base class reads
   * the correct value.
   */
  toggleDrawer() {
    const drawerButton = this.querySelector(".drawer__button");
    const isClosing = this.details.classList.contains("menu-opening");
    const hasOpen = this.details.hasAttribute("open");

    if (isClosing && !hasOpen) {
      this.details.setAttribute("open", "");
    } else if (!isClosing && hasOpen) {
      this.details.removeAttribute("open");
    }

    if (isClosing) {
      this.resetSlideOutMenuPanels();
      header.classList.remove("menu-open");
      drawerButton.classList.remove("menu-is-open");
      body.style.removeProperty("position");
      window.scrollTo(0, this.scrollTopValue);
    } else {
      this.scrollTopValue = window.scrollY;
      header.classList.add("menu-open");
      drawerButton.classList.add("menu-is-open");
    }

    super.toggleDrawer();

    this.querySelectorAll(".drawer__menu-item").forEach(item => {
      item.classList.toggle("is--visible");
    });

    this.querySelectorAll(".drawer__subnav-item").forEach(item => {
      item.classList.toggle("is--visible");
    });
  }

  toggleTrapFocus() {
    super.toggleTrapFocus(this.details);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class DesktopDrawer extends MenuDrawer {
  constructor() {
    super();

    window.addEventListener("resize", e => {
      const isMenuOpen = this.details.classList.contains("menu-opening");

      if (!DeviceDetector.isMobile() || !isMenuOpen) {
        return;
      }

      this.instantlyHideDrawer();
    });
  }
}

customElements.define("desktop-drawer", DesktopDrawer);

class SearchDrawer extends MenuDrawer {
  constructor() {
    super();

    window.addEventListener("resize", e => {
      const isMenuOpen =
        this.details.classList.contains("menu-opening");

      if (!isMenuOpen) {
        return;
      }
    });

    // get button element
    this.btn = this.querySelector(".drawer__button");
    // if this button clicked, close all other drawers
    this.btn.addEventListener("click", () => {
      const headerDrawerDetails = document.querySelector("header-drawer details");
      if (headerDrawerDetails) {
        headerDrawerDetails.removeAttribute("open");
        headerDrawerDetails.classList.remove("menu-opening");
      }
    });
  }
}
customElements.define("search-drawer", SearchDrawer);

class CountryDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  connectedCallback() {
    const triggers = document.querySelectorAll('[id^="country-drawer-button"]');
    if (triggers) {
      triggers.forEach(trigger => {
        trigger.addEventListener("click", (e) => {
          e.preventDefault();
          this.toggleDrawer();
        });
      });
    } else {
      // console.log('No triggers found for country drawer');
    }
  }
}
customElements.define("country-drawer", CountryDrawer);

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(video => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach(video => video.pause());
  document.querySelectorAll("product-model").forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

// unpause all media
function unpauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(video => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "playVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach(video => {
    video.contentWindow.postMessage('{"method":"play"}', "*");
  });
  // document.querySelectorAll('video').forEach(video => video.play());

  document.querySelectorAll("video").forEach(video => {
    let playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise
        .then(_ => {
          // Automatic playback started!
          // Show playing UI.
          // video.play();
        })
        .catch(error => {
          // Auto-play was prevented
          // Show paused UI.
          // if paused, play
          video.play();
        });
    } else {
      // Show paused UI.
    }
  });

  document.querySelectorAll("product-model").forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.play();
  });
}

const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

const fetchConfig = (type = "json") => {
  return {
    method: "POST",
    headers: {
      "Content-Type": `application/${type}`,
      "Accept": `application/${type}`
    }
  };
};

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach(button =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();

    const eventTarget = event.target.name
      ? event.target
      : event.target.closest("button");

    const previousValue = this.input.value;

    eventTarget.name === "increment"
      ? this.input.stepUp()
      : this.input.stepDown();

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;

    button.addEventListener("click", () => {
      const modal = document.querySelector(
        this.getAttribute("data-modal")
      );

      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.dialogHolder = this.querySelector('[role="dialog"]');
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );

    this.addEventListener("keyup", event => {
      if (event.code?.toUpperCase() === "ESCAPE" && !event.target.closest("age-verification-popup")) {
        this.hide();
      }
    });

    this.addEventListener("click", event => {
      if (event.target === this && !event.target.closest("age-verification-popup")) {
        this.hide();
      }
    });

    // Prevent closing the modal dialog when clicking inside the dialog holder
    this.dialogHolder.addEventListener("click", event => {
      event.stopPropagation();
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    bodyScroll.lock(this.dialogHolder);
    this.setAttribute("open", "");
    trapFocus(this, this.dialogHolder);
    window.pauseAllMedia();
  }

  hide() {
    bodyScroll.unlock(this.dialogHolder);
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.unpauseAllMedia();
  }
}

customElements.define("modal-dialog", ModalDialog);

function isIOS() {
  return (
    /iPad|iPhone|iPod|iPad Simulator|iPhone Simulator|iPod Simulator/.test(
      navigator.platform
    ) ||
    (navigator.platform === "MacIntel" &&
      navigator.maxTouchPoints > 1)
  );
}
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector(
          "template"
        ).content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );

      if (isIOS()) {
        deferredElement.controls = true;
      }

      deferredElement.play && deferredElement.play();

      if (focus) deferredElement.focus();
    }
  }
}
customElements.define("deferred-media", DeferredMedia);

class ThemeDropdown extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.dropdown-button');
    this.content = this.querySelector('.dropdown-content');

    this.direction = this.dataset.direction || 'down';
    this.closeOnClick = this.dataset.closeOnClick !== 'false';
    this.closeOnOutsideClick = this.dataset.closeOnOutsideClick !== 'false';
    this.closeOnEscape = this.dataset.closeOnEscape !== 'false';

    this.toggle = this.toggle.bind(this);
    this.handleContentClick = this.handleContentClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);

    // update button span with active item's text
    const activeItem = this.querySelector('li.is-active');
    if (activeItem && this.button) {
      const buttonSpan = this.button.querySelector('span');
      if (buttonSpan) buttonSpan.textContent = activeItem.textContent.trim();
    }
  }

  connectedCallback() {
    if (this.button && this.content) {
      this.button.addEventListener('click', this.toggle);

      if (this.closeOnClick) {
        this.content.addEventListener('click', this.handleContentClick);
      }
      if (this.closeOnOutsideClick) {
        // Close when clicking anywhere outside this element
        document.addEventListener('click', this.handleOutsideClick);
      }
      if (this.closeOnEscape) {
        document.addEventListener('keydown', this.handleKeydown);
      }
    }
  }

  disconnectedCallback() {
    // Clean up listeners when element is removed
    if (this.button) this.button.removeEventListener('click', this.toggle);
    if (this.content && this.closeOnClick)
      this.content.removeEventListener('click', this.handleContentClick);
    if (this.closeOnOutsideClick)
      document.removeEventListener('click', this.handleOutsideClick);
    if (this.closeOnEscape)
      document.removeEventListener('keydown', this.handleKeydown);
  }

  toggle(event) {
    event.stopPropagation();
    document.querySelectorAll('theme-dropdown[open], localization-form[open]').forEach(dropdown => {
      if (dropdown !== this) dropdown.removeAttribute('open');
    });

    if (this.hasAttribute('open')) {
      this.removeAttribute('open');
    } else {
      this.setAttribute('open', '');
    }

    const activeItem = this.querySelector('li.is-active');
    if (activeItem && this.button) {
      const buttonSpan = this.button.querySelector('span');
      if (buttonSpan) buttonSpan.textContent = activeItem.textContent.trim();
    }
  }

  handleContentClick(event) {
    this.removeAttribute('open');
  }

  handleOutsideClick(event) {
    if (this.hasAttribute('open') && !this.contains(event.target)) {
      this.removeAttribute('open');
    }
  }

  handleKeydown(event) {
    if (event.code && event.code.toUpperCase() === 'ESCAPE' && this.hasAttribute('open')) {
      this.removeAttribute('open');
    }
  }
}
customElements.define('theme-dropdown', ThemeDropdown);


class LocalizationForm extends ThemeDropdown {
  constructor() {
    super();
    this.form = this.closest('form');
    this.inputName = this.button?.id.includes('language') ? 'language_code' : 'country_code';
    this.handleLinkClick = this.handleLinkClick.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();

    // Add click handlers to links
    const links = this.content?.querySelectorAll('a[data-value]') || [];
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.handleLinkClick(link);
      });
    });
  }

  handleLinkClick(link) {
    const value = link.getAttribute('data-value');
    if (!value || !this.form) return;

    // Find and update hidden input
    const input = this.form.querySelector(`input[name="${this.inputName}"]`);
    if (!input) return;

    input.value = value;

    // Update active state
    this.querySelectorAll('li').forEach(li => li.classList.remove('is-active'));
    link.closest('li')?.classList.add('is-active');

    // Update button text
    const buttonTextContent = this.button.querySelector('.dropdown-button__text-content');
    if (buttonTextContent) {
      buttonTextContent.textContent = link.textContent.trim();
    }

    // Close dropdown
    this.removeAttribute('open');

    // Submit form directly
    this.form.submit();
  }
}
customElements.define('localization-form', LocalizationForm);

class AccordionDefault extends HTMLElement {
  constructor() {
    super();

    this.hideMultiple = this.hasAttribute("data-hide-multiple");
    this.summaryElements = this.querySelectorAll("summary");

    this.setInitialAccessibilityAttr();

    this.addEventListener("click", e => {
      let isBtn = e.target.classList.contains("js-btn");

      if (!isBtn) {
        isBtn = e.target.closest("summary.js-btn");
      }

      if (!isBtn) return;

      e.preventDefault();

      this.toggleDropdown(
        e.target.classList.contains("js-btn")
          ? e.target
          : e.target.closest("summary")
      );
      this.collapseInactiveItems();
    });

    this.addEventListener("keydown", e => {
      const isEscapeKey = e.key === "Escape";

      if (!isEscapeKey) {
        return;
      }

      const closestOpenDetails = document.activeElement.closest(
        "details.is-active"
      );

      if (!closestOpenDetails) {
        return;
      }

      const btn = closestOpenDetails.querySelector("summary");

      const menuDrawer = this.closest("menu-drawer");

      if (menuDrawer?.classList.contains("facets__drawer")) {
        menuDrawer.toggleDrawer();
        return;
      }

      this.toggleDropdown(btn);
      this.collapseInactiveItems();
    });
  }

  collapseInactiveItems() {
    if (!this.hideMultiple) return;
    const allSummaryElements = document.querySelectorAll(
      "accordion-default summary"
    );
    allSummaryElements.forEach(summary => {
      const accordionDefault = summary.closest("accordion-default");
      accordionDefault.toggleDropdown(summary, true);
    });
  }

  toggleDropdown(btn, forceClose) {
    const dropdown = btn.nextElementSibling;
    const isDropdownTransitioning = dropdown.classList.contains(
      "is-transitioning"
    );

    if (isDropdownTransitioning) {
      return;
    }

    const details = btn.parentElement;
    const accordionContainer = details.closest(".product__accordion");

    if (forceClose) {
      details.classList.remove("is-active");
      details.removeAttribute("open");
      btn.setAttribute("aria-expanded", false);
      dropdown.style.height = "0px";
      return;
    }

    details.classList.toggle("is-active");

    const isDetailsActive = details.classList.contains("is-active");

    btn.setAttribute("aria-expanded", isDetailsActive);

    if (isDetailsActive) {
      details.setAttribute("open", "");

      dropdown.style.height = `${dropdown.scrollHeight}px`;
      setTimeout(() => {
        if (accordionContainer) {
          const rect = accordionContainer.getBoundingClientRect();
          const scrollY = window.scrollY + rect.top - 150;

          window.scrollTo({
            top: scrollY,
            behavior: "smooth"
          });
        }
      }, 150);
    } else {
      dropdown.style.height = `${dropdown.scrollHeight}px`;

      setTimeout(() => {
        dropdown.style.height = "0px";
      }, 0);
    }

    dropdown.classList.add("is-transitioning");
    dropdown.addEventListener(
      "transitionend",
      handleHeightTransition
    );

    function handleHeightTransition(e) {
      dropdown.removeEventListener(
        "transitionend",
        handleHeightTransition
      );
      dropdown.classList.remove("is-transitioning");

      if (isDetailsActive) {
        dropdown.style.height = "auto";
        return;
      }

      details.removeAttribute("open");
      btn.focus();
    }
  }

  setInitialAccessibilityAttr() {
    this.summaryElements.forEach(summaryElement => {
      const detailsElement = summaryElement.parentElement;
      const dropdown = summaryElement.nextElementSibling;
      const isDetailsOpen = detailsElement.hasAttribute("open");

      summaryElement.setAttribute("role", "button");
      summaryElement.setAttribute("aria-controls", dropdown.id);
      summaryElement.setAttribute("aria-expanded", isDetailsOpen);
    });
  }
}

customElements.define("accordion-default", AccordionDefault);

const nav = document.querySelector(".js-nav");

nav?.addEventListener("click", function (e) {
  const isHoverDisabled = matchMedia("(hover: none)").matches;
  const isLink = e.target.classList.contains("js-nav-link");

  if (!isHoverDisabled || !isLink) {
    return;
  }

  const link = e.target;
  const linkItem = link.parentElement;
  const linksList = linkItem.parentElement;
  const activeLinkItem = linksList.querySelector(
    ".js-nav-item.is-active"
  );
  const hasDropdown = linkItem.classList.contains("has-dropdown");

  if (activeLinkItem !== linkItem) {
    activeLinkItem?.classList.remove("is-active");
  }

  if (!hasDropdown) {
    return;
  }

  e.preventDefault();

  linkItem.classList.toggle("is-active");
});

document.addEventListener("click", function (e) {
  const targetActiveLinkItem = e.target.closest(
    ".js-nav-item.is-active"
  );

  if (targetActiveLinkItem) {
    return;
  }

  const activeLinkItems = document.querySelectorAll(
    ".js-nav-item.is-active"
  );

  if (activeLinkItems.length == 0) {
    return;
  }

  activeLinkItems.forEach(activeLinkItem => {
    activeLinkItem.classList.remove("is-active");
  });
});

let navItems = document.querySelectorAll(
  ".js-nav-item.has-dropdown:not(.dropdown)"
);

window.addEventListener("shopify:section:load", function () {
  navItems = document.querySelectorAll(
    ".js-nav-item.has-dropdown:not(.dropdown)"
  );
});

["DOMContentLoaded", "resize"].forEach(eventType => {
  window.addEventListener(eventType, () => {
    navItems = document.querySelectorAll(
      ".js-nav-item.has-dropdown:not(.dropdown)"
    );
    navItems.forEach(navItem => {
      const dropdown = navItem.querySelector(".js-dropdown");

      if (!dropdown) {
        return;
      }

      const { y, height } = navItem.getBoundingClientRect();
      const itemTop = y + height;
      const dropdownY = dropdown.getBoundingClientRect().y;
      const isSameOffset = itemTop === dropdownY;

      if (isSameOffset) {
        return;
      }

      const difference = Math.round(dropdownY - itemTop);

      navItem.style.setProperty("--after-height", `${difference}px`);
    });
  });
});

// Add is scrolled class for header when transparent and sticky are enabled

let hero =
  document.querySelector(".hero-banner") ||
  document.querySelector("main section");

const headerInner = header?.querySelector('.header__inner');
const megaMenus = document.querySelectorAll('nav.js-nav');

megaMenus.forEach(megaMenu => {
  if (megaMenu) {
    function toggleHeaderTransparency() {
      const hasVisibleDropdown = megaMenu.querySelector('.js-dropdown.is-visible');

      if (hasVisibleDropdown) {
        header.classList.add('is-megamenu-open');
      } else {
        header.classList.remove('is-megamenu-open');
      }
    }

    megaMenu.querySelectorAll('.js-nav-item').forEach(item => {
      const menuContent = item.querySelector('.js-dropdown');

      item.addEventListener('mouseenter', () => {
        if (header.classList.contains('is-keyboard-nav')) {
          header.classList.remove('is-keyboard-nav');
          const focused = headerInner?.querySelector('[tabindex="0"]');
          if (focused && headerInner.contains(document.activeElement)) {
            document.activeElement.blur();
          }
        }

        const menuItem = item.getAttribute('data-menu-item');
        if (menuItem === null) {
          return;
        }
        closeAllDropdowns();
        if (menuContent) {
          menuContent.classList.add('is-visible');
        }
        toggleHeaderTransparency();
      });

      item.addEventListener('mouseleave', e => {
        const related = e.relatedTarget;
        if (related && (menuContent?.contains(related) || item.contains(related) || megaMenu.contains(related))) {
          return;
        }
        closeAllDropdowns();
        toggleHeaderTransparency();
      });

      if (menuContent) {
        menuContent.addEventListener('mouseleave', e => {
          const related = e.relatedTarget;
          if (related && (menuContent.contains(related) || item.contains(related) || megaMenu.contains(related))) {
            return;
          }
          closeAllDropdowns();
          toggleHeaderTransparency();
        });
      }
    });
    megaMenu.addEventListener('mouseleave', () => {
      closeAllDropdowns();
      toggleHeaderTransparency();
    });

    function closeAllDropdowns() {
      megaMenu.querySelectorAll('.js-dropdown.is-visible').forEach(dropdown => {
        const item = dropdown.closest('.js-nav-item');
        const menuItem = item?.getAttribute('data-menu-item');
        const allSublinks = megaMenu.querySelectorAll('.header__nav-sublinks');

        allSublinks.forEach((sublink) => {
          if (sublink.classList.contains('is-visible')) {
            sublink.classList.remove("is-visible");
          }
        })
        if (menuItem === null) {
          return;
        }
        dropdown.classList.remove('is-visible');
      });
    }
  }
});

document.querySelectorAll('.header__nav-item.dropdown [data-child-menu-item]').forEach(childItem => {
  const childMenuContent = childItem.querySelector('[data-child-menu-content]');

  childItem.addEventListener('mouseenter', () => {
    document.querySelectorAll('.header__nav-item.dropdown [data-child-menu-content]').forEach(menuContent => {
      menuContent.classList.remove('is-visible');
    });
    childMenuContent?.classList.add('is-visible');
  });

  childItem.addEventListener('mouseleave', e => {
    const related = e.relatedTarget;
    // if mouse enters another sibling `data-child-menu-item`, remove 'is-visible'
    if (
      related &&
      related.closest('[data-child-menu-item]') !== childItem &&
      related.closest('[data-child-menu-item]')
    ) {
      childMenuContent?.classList.remove('is-visible');
    }
  });
});


/* --------------- *** Mega Menu Keyboard Navigation *** --------------- */

/**
 * Unified keyboard-accessible header navigation.
 *
 * All visible top-level items (main nav links, additional links, util icons)
 * form a single arrow-navigable row from left to right.
 *
 * - Arrow Left/Right moves between all top-level header items.
 * - Tab enters the open submenu (dropdown) of the currently focused item.
 * - Escape from a submenu returns focus to the parent top-level item.
 * - Escape from the top-level row closes everything and blurs the header.
 * - Focus on an item with a dropdown opens it (mirrors hover).
 */
(function initHeaderKeyboardNav() {
  const header = document.querySelector('.js-header');

  if (!header) return;

  const headerInner = header.querySelector('.header__inner');

  if (!headerInner) return;

  const DESKTOP_BREAKPOINT = 990;

  const isDesktop = () => window.innerWidth >= DESKTOP_BREAKPOINT;

  /**
   * Collects all top-level interactive items in visual order across
   * the entire header: main nav links, additional links, util buttons.
   */
  const getTopLevelItems = () => {
    const mainNavLinks = Array.from(
      headerInner.querySelectorAll('.header__nav .js-mega-menu > .js-nav-item > .js-nav-link')
    );

    const additionalNavLinks = Array.from(
      headerInner.querySelectorAll('.header__utils .js-mega-menu .js-nav-item > .js-nav-link')
    );

    const utilLinks = Array.from(
      headerInner.querySelectorAll('.header__utils-items > .header__utils-item:not(.header__nav-additional) > a, .header__utils-items > .header__utils-item:not(.header__nav-additional) .drawer__button')
    );

    return [...mainNavLinks, ...additionalNavLinks, ...utilLinks];
  };

  const closeAllDropdowns = () => {
    headerInner.querySelectorAll('.js-dropdown.is-visible').forEach(d => {
      d.classList.remove('is-visible');
      d.closest('.js-nav-item')?.querySelector(':scope > .js-nav-link')
        ?.setAttribute('aria-expanded', 'false');
    });

    headerInner.querySelectorAll('.header__nav-sublinks.is-visible').forEach(s => {
      s.classList.remove('is-visible');
    });

    header.classList.remove('is-megamenu-open');
  };

  // Moves roving tabindex to a specific item and focuses it.
  const focusNavItem = (allItems, fromIndex, toIndex) => {
    if (fromIndex >= 0) {
      allItems[fromIndex].setAttribute('tabindex', '-1');
    }

    allItems[toIndex].setAttribute('tabindex', '0');
    allItems[toIndex].focus();
  };

  // Resets all items to tabindex=-1 and restores the first item to 0.
  const resetNavTabindices = (allItems) => {
    allItems.forEach(item => item.setAttribute('tabindex', '-1'));
    allItems[0].setAttribute('tabindex', '0');
  };

  /**
   * Releases keyboard nav — resets tabindices and allows focus
   * to leave the header naturally.
   */
  const releaseHeaderKeyboardNav = (allItems) => {
    closeAllDropdowns();
    resetNavTabindices(allItems);
    header.classList.remove('is-keyboard-nav');
  };

  // Focuses the first interactive element inside a visible dropdown.
  const focusFirstDropdownItem = (dropdown) => {
    const firstFocusable = dropdown.querySelector(
      'a, button, [tabindex]:not([tabindex="-1"])'
    );

    firstFocusable?.focus();
  };

  const openDropdownForItem = (navItem) => {
    const dropdown = navItem.querySelector('.js-dropdown');

    if (!dropdown) return;

    closeAllDropdowns();

    dropdown.classList.add('is-visible');
    navItem.querySelector(':scope > .js-nav-link')?.setAttribute('aria-expanded', 'true');
    header.classList.add('is-megamenu-open');
  };

  const isInSubmenu = (element) => {
    return element.closest('.js-dropdown') !== null;
  };

  /* --------------- *** Tabindex Management *** --------------- */

  const applyDesktopTabindex = () => {
    const allItems = getTopLevelItems();

    allItems.forEach((link, i) => {
      link.setAttribute('tabindex', i === 0 ? '0' : '-1');
    });
  };

  const clearTabindexOverrides = () => {
    const allItems = getTopLevelItems();

    allItems.forEach(link => {
      link.removeAttribute('tabindex');
    });
  };

  const syncTabindex = () => {
    if (isDesktop()) {
      applyDesktopTabindex();
    } else {
      clearTabindexOverrides();
    }
  };

  syncTabindex();

  let resizeTimer;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncTabindex, 150);
  });

  /* --------------- *** Focus Handlers *** --------------- */

  const attachFocusHandlers = () => {
    headerInner.querySelectorAll('.js-nav-item').forEach(item => {
      const link = item.querySelector(':scope > .js-nav-link');

      if (!link) return;

      link.addEventListener('focus', () => {
        if (!isDesktop()) return;

        if (item.classList.contains('has-dropdown')) {
          openDropdownForItem(item);
        } else {
          closeAllDropdowns();
          header.classList.add('is-megamenu-open');
        }
      });
    });
  };

  attachFocusHandlers();

  /* --------------- *** Keydown Handler *** --------------- */

  headerInner.addEventListener('keydown', (e) => {
    if (!isDesktop()) return;

    const allItems = getTopLevelItems();
    const activeElement = document.activeElement;
    const currentIndex = allItems.indexOf(activeElement);
    const isOnTopLevel = currentIndex !== -1;
    const isInsideSubmenu = isInSubmenu(activeElement);

    if (['ArrowLeft', 'ArrowRight', 'ArrowDown', 'Escape', 'Tab'].includes(e.key)) {
      header.classList.add('is-keyboard-nav');
    }

    if (e.key === 'Escape') {
      e.preventDefault();

      if (isInsideSubmenu) {
        const closestDropdown = activeElement.closest('.js-dropdown');
        const parentNavItem = closestDropdown?.closest('.js-nav-item');
        const topLink = parentNavItem?.querySelector(':scope > .js-nav-link');

        closeAllDropdowns();

        if (topLink) {
          allItems.forEach(item => item.setAttribute('tabindex', '-1'));
          topLink.setAttribute('tabindex', '0');
          header.classList.add('is-megamenu-open');
          topLink.focus();
        }

        return;
      }

      const openDrawer = activeElement.closest('.drawer__container[open]');

      if (openDrawer) {
        const summary = openDrawer.querySelector(':scope > summary');

        openDrawer.classList.remove('menu-opening');
        setTimeout(() => openDrawer.removeAttribute('open'), 300);

        document.body.style.overflow = '';
        document.body.style.width = '';
        document.body.classList.remove('drawer--is-open');

        if (summary) {
          summary.classList.remove('menu-is-open');
          summary.setAttribute('aria-expanded', 'false');

          allItems.forEach(item => item.setAttribute('tabindex', '-1'));
          summary.setAttribute('tabindex', '0');
          summary.focus();

          header.classList.add('is-megamenu-open');
        }

        return;
      }

      closeAllDropdowns();
      activeElement?.blur();

      return;
    }

    if (isOnTopLevel) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        focusNavItem(allItems, currentIndex, (currentIndex + 1) % allItems.length);

        return;
      }

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        focusNavItem(allItems, currentIndex, (currentIndex - 1 + allItems.length) % allItems.length);

        return;
      }

      if (e.key === 'ArrowDown' || (e.key === 'Tab' && !e.shiftKey)) {
        const openDropdown = headerInner.querySelector('.js-dropdown.is-visible');

        if (openDropdown) {
          e.preventDefault();
          focusFirstDropdownItem(openDropdown);

          return;
        }

        if (e.key === 'ArrowDown') return;

        const nextIndex = currentIndex + 1;

        if (nextIndex < allItems.length) {
          e.preventDefault();
          focusNavItem(allItems, currentIndex, nextIndex);
        } else {
          releaseHeaderKeyboardNav(allItems);
        }

        return;
      }
    }

    /* --------------- *** Submenu Arrow Navigation *** --------------- */

    if (isInsideSubmenu) {
      const closestDropdown = activeElement.closest('.js-dropdown');

      if (!closestDropdown) return;

      const getFocusableItems = (container) => {
        return Array.from(
          container.querySelectorAll('a:not([tabindex="-1"]), button:not([tabindex="-1"]), [tabindex="0"]')
        ).filter(el => el.offsetParent !== null);
      };

      const activeSublinks = closestDropdown.querySelector('.header__nav-sublinks.is-visible');
      const focusContext = activeSublinks && activeSublinks.contains(activeElement)
        ? activeSublinks
        : closestDropdown;

      const focusableItems = getFocusableItems(focusContext);
      const focusedIndex = focusableItems.indexOf(activeElement);

      if (e.key === 'Tab') {
        const parentNavItem = closestDropdown.closest('.js-nav-item');
        const topLink = parentNavItem?.querySelector(':scope > .js-nav-link');
        const topIndex = allItems.indexOf(topLink);

        // Tab forward from last submenu item → next top-level item or leave header.
        if (!e.shiftKey && focusedIndex === focusableItems.length - 1) {
          e.preventDefault();
          closeAllDropdowns();

          const nextIndex = topIndex + 1;

          if (nextIndex < allItems.length) {
            resetNavTabindices(allItems);
            focusNavItem(allItems, -1, nextIndex);
          } else {
            releaseHeaderKeyboardNav(allItems);
            activeElement.blur();
          }

          return;
        }

        // Shift+Tab from first submenu item → return to parent top-level link.
        if (e.shiftKey && focusedIndex === 0) {
          e.preventDefault();
          closeAllDropdowns();

          if (topLink) {
            resetNavTabindices(allItems);
            topLink.setAttribute('tabindex', '0');
            header.classList.add('is-megamenu-open');
            topLink.focus();
          }

          return;
        }

        return;
      }

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const nextIdx = (focusedIndex + 1) % focusableItems.length;
        focusableItems[nextIdx]?.focus();

        return;
      }

      if (e.key === 'ArrowUp') {
        e.preventDefault();

        if (focusedIndex <= 0) {
          const parentNavItem = closestDropdown.closest('.js-nav-item');
          const topLink = parentNavItem?.querySelector(':scope > .js-nav-link');

          if (topLink) {
            allItems.forEach(item => item.setAttribute('tabindex', '-1'));
            topLink.setAttribute('tabindex', '0');
            topLink.focus();
          }

          return;
        }

        const prevIdx = focusedIndex - 1;
        focusableItems[prevIdx]?.focus();

        return;
      }

    }
  });

  /* --------------- *** Focusout Handler *** --------------- */

  headerInner.addEventListener('focusout', () => {
    if (!isDesktop()) return;

    requestAnimationFrame(() => {
      if (!headerInner.contains(document.activeElement)) {
        closeAllDropdowns();
        header.classList.remove('is-keyboard-nav');
      }
    });
  });

  /* --------------- *** Logo Focus *** --------------- */

  const logoLink = header.querySelector('.header__logo a');

  if (logoLink) {
    logoLink.addEventListener('focus', () => {
      if (!isDesktop()) return;

      closeAllDropdowns();
      header.classList.add('is-megamenu-open');
    });

    logoLink.addEventListener('blur', () => {
      if (!isDesktop()) return;

      requestAnimationFrame(() => {
        if (!headerInner.contains(document.activeElement)) {
          header.classList.remove('is-megamenu-open');
        }
      });
    });
  }

  /* --------------- *** Section Reload Support *** --------------- */

  window.addEventListener('shopify:section:load', initHeaderKeyboardNav);
})();


/* --------------- *** Animations *** --------------- */

/**
 * observeAnimationElements() registers nodes whose class name
 * contains "js-animation-" (e.g. js-animation-fade-in). CSS
 * gives them a paused fade-in; .animation-init sets
 * animation-play-state to running (see base.css "Animations").
 *
 * For each intersecting target we unobserve immediately so the
 * handler runs only once per element (no ongoing scroll cost).
 *
 * On animationend, .animation-none sets animation: none so the
 * element is not left with an active animation definition.
 */
const animationObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) {
      return;
    }

    const target = entry.target;

    animationObserver.unobserve(target);

    requestAnimationFrame(() => {
      target.classList.add("animation-init");
      target.addEventListener(
        "animationend",
        () => {
          target.classList.add("animation-none");
        },
        {
          once: true
        }
      );
    });
  });
}, { rootMargin: "200px" });

observeAnimationElements();

window.addEventListener("shopify:section:load", () => {
  observeAnimationElements();
});

function observeAnimationElements() {
  const animationElements = document.querySelectorAll(
    '[class*="js-animation-"]'
  );

  animationElements.forEach(animationElement => {
    animationObserver.observe(animationElement);
  });
}

function preventDefault(event) {
  event.preventDefault();
}

// DropdownInput

class DropdownInput extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector("select");
    this.dropdown = null;
    this.buttons = null;
    this.detailsTemplate = this.querySelector(
      'template[data-name="details"]'
    );
    this.optionTemplate = this.querySelector(
      'template[data-name="option"]'
    );
    if (!this.select) return;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.select.classList.add("hidden");
    this.appendTemplate();
  }

  appendTemplate() {
    const detailsTemplate =
      this.detailsTemplate.content.firstElementChild.cloneNode(true);
    const optionTemplate = this.optionTemplate.content;
    const options = Array.from(this.select.options);
    if (options.length === 0) return;
    const selectedOption = options.find(option => option.selected);
    detailsTemplate.querySelector("[data-label]").textContent =
      selectedOption.label;

    options.forEach(option => {
      const html = optionTemplate.cloneNode(true);
      const button = html.querySelector("button");
      const li = html.querySelector("li");

      button.setAttribute("data-value", option.value);
      button.textContent = option.label;
      button.toggleAttribute("disabled", option.disabled);
      li.classList.toggle("is-active", option.selected);
      detailsTemplate.querySelector("[data-options]").append(html);
    });

    this.append(detailsTemplate);
    this.dropdown = this.querySelector("details");
    this.buttons = this.dropdown.querySelectorAll("button");
    this.setHandlers();
  }

  update() {
    this.dropdown = null;
    this.buttons = null;
    this.querySelector("details")?.remove();
    this.appendTemplate();
  }

  setHandlers() {
    this.querySelector("summary").addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );
    this.buttons.forEach((button, index) => {
      button.addEventListener("click", event =>
        this.onOptionSelect(event, index)
      );
    });
  }

  onOptionSelect(event, index) {
    event.preventDefault();
    Array.from(this.select.options).forEach(option =>
      option.removeAttribute("selected")
    );

    this.select.options[index].setAttribute("selected", "selected");
    this.select.value = event.target.dataset.value;
    this.select.dispatchEvent(new Event("change", { bubbles: true }));
    this.querySelector("[data-label]").textContent =
      this.select.options[index].label;
    this.setSelectedOption(event.target);

    // when option is selected, update the dropdown
    this.update();
  }

  setSelectedOption(buttonOption) {
    const buttonEl = buttonOption;
    this.buttons.forEach(button => {
      button.parentElement.classList.remove("is-active");
    });
    buttonEl.parentElement.classList.add("is-active");
    this.select.dispatchEvent(new Event("change"));
    this.select.closest("form")?.dispatchEvent(new Event("input"));
    this.close(
      undefined,
      this.dropdown.querySelector("summary"),
      this.dropdown
    );
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    isOpen
      ? this.close(event, summaryElement, detailsElement)
      : this.open(summaryElement, detailsElement);
  }

  open(summaryElement, detailsElement) {
    setTimeout(() => {
      detailsElement.classList.add("is-open");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(detailsElement, summaryElement);
  }

  close(event, summaryElement, detailsElement) {
    if (event) {
      event.preventDefault();
    }

    detailsElement.classList.remove("is-open");
    removeTrapFocus(summaryElement);
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      elapsedTime < 300 // Increase for animation duration if necessary
        ? window.requestAnimationFrame(handleAnimation)
        : detailsElement.removeAttribute("open");
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define("dropdown-input", DropdownInput);

// Countdown Timer
class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    const timezone = this.dataset.timezone,
      date = this.dataset.date.split("-").filter(function (el) {
        return el != "";
      }),
      day = parseInt(date[0]),
      month = parseInt(date[1]),
      year = parseInt(date[2]);

    let time = this.dataset.time,
      tarhour = 0,
      tarmin = 0;

    if (time != null) {
      time = time.split(":");
      tarhour = parseInt(time[0]);
      tarmin = parseInt(time[1]);
    }

    const date_string =
      month +
      "/" +
      day +
      "/" +
      year +
      " " +
      (tarhour < 10 ? "0" + tarhour : tarhour) +
      ":" +
      (tarmin < 10 ? "0" + tarmin : tarmin) +
      " GMT" +
      timezone;

    this.countDownDate = new Date(date_string).getTime();
    this.timerInterval = null;

    // Son güncellenen değerleri saklamak için yeni özellikler
    this.lastDays = -1;
    this.lastHours = -1;
    this.lastMinutes = -1;
  }

  connectedCallback() {
    this.startTimer();
  }

  disconnectedCallback() {
    this.stopTimer();
  }

  startTimer() {
    this.updateTime(true);

    this.timerInterval = setInterval(() => {
      this.updateTime(false);
    }, 1000);
  }

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  updateTime(initialUpdate = false) {
    const _this = this;
    const timer_layout = _this.dataset.timerLayout;
    const now = new Date().getTime();
    let distance = _this.countDownDate - now;

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    let daysBlock = _this.querySelector(".days .countdown-timer__column-number");
    let hoursBlock = _this.querySelector(".hours .countdown-timer__column-number");
    let minutesBlock = _this.querySelector(".minutes .countdown-timer__column-number");
    let secondsBlock = _this.querySelector(".seconds .countdown-timer__column-number");
    let countdownTimerColumns = _this.querySelector(".countdown-timer__columns");
    let countdownTimerMessage = _this.querySelector(".countdown-timer__message");

    if (distance < 0) {
      _this.stopTimer();

      if (daysBlock) daysBlock.innerHTML = 0;
      if (hoursBlock) hoursBlock.innerHTML = 0;
      if (minutesBlock) minutesBlock.innerHTML = 0;
      if (secondsBlock) secondsBlock.innerHTML = 0;

      _this.classList.add("loading-effect");
      _this.setAttribute("data-is-ended", "true");

      if (timer_layout !== "1") {
        if (countdownTimerColumns) countdownTimerColumns.classList.add("hidden");
        if (countdownTimerMessage) countdownTimerMessage.classList.remove("hidden");
      }

      if (timer_layout === "1") {
        let calloutBannerContentHeading = _this.closest(".callout-banner")?.querySelector(".callout-banner__content-heading");
        if (calloutBannerContentHeading) calloutBannerContentHeading.innerHTML = _this.dataset.endMessage;
      }
    } else {
      // update time when necessary

      if (secondsBlock) secondsBlock.innerHTML = CountdownTimer.addZero(seconds);

      if (initialUpdate || this.lastMinutes !== minutes) {
        if (minutesBlock) minutesBlock.innerHTML = CountdownTimer.addZero(minutes);
        this.lastMinutes = minutes;
      }

      if (initialUpdate || this.lastHours !== hours) {
        if (hoursBlock) hoursBlock.innerHTML = CountdownTimer.addZero(hours);
        this.lastHours = hours;
      }

      if (initialUpdate || this.lastDays !== days) {
        if (daysBlock) {
          daysBlock.innerHTML = CountdownTimer.addZero(days);
        }
        this.lastDays = days;
      }

      if (days === 0 && daysBlock && !initialUpdate) {
        daysBlock.parentElement.parentElement.remove();
      }

      _this.classList.remove("loading-effect");
    }
  }

  static addZero(x) {
    return x < 10 && x >= 0 ? "0" + x : x;
  }
}
customElements.define("countdown-timer", CountdownTimer);

if (!customElements.get("text-truncator")) {
  class TextTruncator extends HTMLElement {
    constructor() {
      super();
      this.initElements();
    }

    connectedCallback() {
      this.setupTextTruncation();
      // Uncomment the following line to enable resizing functionality
      // window.addEventListener('resize', this.setupTextTruncation.bind(this));
    }

    initElements() {
      this.textTruncatorButton = this.querySelector(".text-truncator__button");
      this.textTruncatorButtonText = this.textTruncatorButton?.querySelector(".text-truncator__button-text");
      this.textTruncatorIconPlus = this.textTruncatorButton?.querySelector(".icon-plus");
      this.textTruncatorIconMinus = this.textTruncatorButton?.querySelector(".icon-minus");
    }

    setupTextTruncation() {
      const textTruncator = this.querySelector(".text-truncator");
      textTruncator.style.display = "block"; // show the block initially

      const { lineHeight, lineCount, maxLineCount } = this.calculateLineCounts(textTruncator);

      if (lineCount > maxLineCount) {
        this.applyTextTruncation(textTruncator, lineHeight, maxLineCount);
        this.setupButton(textTruncator);
      } else {
        this.removeTextTruncation(textTruncator);
      }
    }

    calculateLineCounts(element) {
      const lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
      const lineCount = Math.floor(element.clientHeight / lineHeight);
      const maxLineCount = parseInt(this.dataset.maxLineCount);

      return { lineHeight, lineCount, maxLineCount };
    }

    applyTextTruncation(element, lineHeight, maxLineCount) {
      element.classList.add("text-truncator--hidden");

      const maxHeight = `${lineHeight * maxLineCount}px`;
      const style = document.createElement("style");
      style.innerHTML = `.text-truncator--hidden { max-height: ${maxHeight}; }`;
      document.head.appendChild(style);
      if (this.textTruncatorButton) {
        this.textTruncatorButton.style.display = "";
      }
    }

    removeTextTruncation(element) {
      element.classList.remove("text-truncator--hidden");

      if (this.textTruncatorButton) {
        this.textTruncatorButton.style.display = "none";
      }
    }

    setupButton(textTruncator) {
      if (this.textTruncatorButton) {
        this.textTruncatorButtonText.innerHTML = `<span>${this.dataset.readMore}</span>`;
        this.toggleIcons("plus");
        this.textTruncatorButton.addEventListener("click", (event) => {
          event.preventDefault();
          this.toggleTextTruncation(textTruncator);
        });
      }
    }

    toggleTextTruncation(textTruncator) {
      const paragraphs = textTruncator.querySelectorAll("p");
      const isHidden = textTruncator.classList.contains("text-truncator--hidden");

      paragraphs.forEach((paragraph, index) => {
        paragraph.style.marginTop = isHidden && index !== 0 ? "1rem" : "";
      });

      textTruncator.classList.toggle("text-truncator--hidden");
      this.textTruncatorButtonText.innerHTML = `<span>${isHidden ? this.dataset.readLess : this.dataset.readMore}</span>`;
      this.toggleIcons(isHidden ? "minus" : "plus");

      // on mobile, if the text is expanded, set max-height to 4rem
      if (isHidden && DeviceDetector.isMobile()) {
        textTruncator.style.overflow = "scroll";
      } else {
        textTruncator.style.maxHeight = "";
        textTruncator.style.overflow = "";
      }
    }

    toggleIcons(iconType) {
      this.textTruncatorIconPlus.style.display = iconType === "plus" ? "inline-block" : "none";
      this.textTruncatorIconMinus.style.display = iconType === "minus" ? "inline-block" : "none";
    }
  }
  customElements.define("text-truncator", TextTruncator);
}

class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.vertical_offset_for_trigger = window.innerHeight * 0.5;
    this.addEventListener("click", this.scrollToTop.bind(this));
  }

  scrollToTop() {
    window.scroll({
      top: 0,
      behavior: "smooth"
    });
  }

  connectedCallback() {
    window.addEventListener("scroll", () => this.handleScroll(), {
      passive: true
    });
  }

  handleScroll() {
    const top = window.pageYOffset;
    if (top > this.vertical_offset_for_trigger) {
      this.classList.remove("hide");
    } else {
      this.classList.add("hide");
    }
  }
}

customElements.define("back-to-top", BackToTop);

const submenuButtons = document.querySelectorAll(
  ".drawer__submenu-btn"
);

submenuButtons.forEach(button => {
  button.addEventListener("click", function () {
    const parentDiv = button.parentElement;
    const isActive = parentDiv.classList.contains("is-active");

    // Etkin öğeyi doğrula
    const submenuSecond = parentDiv.querySelector(
      ".drawer__submenu-second"
    );
    if (submenuSecond) {
      submenuSecond.style.height = isActive ? "0px" : "auto";
    }

    const submenuItems = document.querySelectorAll(
      ".drawer__submenu-first-item"
    );
    submenuItems.forEach(item => {
      item.classList.remove("is-active");
      const submenu = item.querySelector(".drawer__submenu-second");
      if (submenu) {
        submenu.style.height = "0px";
      }
    });

    if (!isActive) {
      parentDiv.classList.add("is-active");
      const submenuSec = parentDiv.querySelector(
        ".drawer__submenu-second"
      );
      if (submenuSec) {
        submenuSec.style.height = "auto";
      }
    }
  });
});

/* constants */
const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  cartError: "cart-error"
};

document.addEventListener("DOMContentLoaded", function () {
  const PANEL_TRANSITION_MS = 300;
  const NESTED_TRANSITION_MS = 100;
  const FOCUS_DELAY_MS = 350;

  const menuLinks = document.querySelectorAll("button.menu-link");
  const mobileDrawerContent = document.querySelector(".drawer__content--nav");

  /* --------------- *** Slide-out Panel Helpers *** --------------- */

  /**
   * Resets a menu panel's scroll position once it is the active scroll container.
   */
  const resetMenuPanelScroll = (panel) => {
    if (!panel) return;

    panel.scrollTop = 0;

    requestAnimationFrame(() => {
      panel.scrollTop = 0;
    });
  };

  /**
   * Silently deactivate a panel without any visible slide transition.
   * Used when clearing stacked panels behind the current one on back-to-root.
   */
  const deactivatePanelInstantly = (panel) => {
    panel.style.transition = "none";
    panel.classList.remove("is-active");
    panel.removeAttribute("inert");
    panel.style.opacity = "";
    panel.scrollTop = 0;

    requestAnimationFrame(() => {
      panel.style.transition = "";
    });
  };

  // Slides the current panel out to the right (back transition).
  const slideOutPanel = (panel) => {
    panel.classList.remove("is-active");
    panel.classList.add("is-back", "non-active");
    panel.removeAttribute("inert");

    setTimeout(() => {
      panel.classList.remove("non-active");
      panel.scrollTop = 0;
    }, PANEL_TRANSITION_MS);
  };

  const restorePrimaryMenu = (primaryMenuPanel) => {
    if (!primaryMenuPanel) return;

    primaryMenuPanel.style.opacity = "";
    primaryMenuPanel.removeAttribute("inert");
    primaryMenuPanel.removeAttribute("aria-hidden");
  };

  /* --------------- *** Back Navigation *** --------------- */

  const handleBackNavigation = ({ currentPanel, targetPanel, allPanels, primaryMenuPanel }) => {
    if (currentPanel) {
      slideOutPanel(currentPanel);
    }

    if (targetPanel) {
      targetPanel.removeAttribute("inert");

      const focusTarget = targetPanel.querySelector("button.menu-header");

      if (focusTarget) {
        setTimeout(() => {
          focusTarget.focus({ preventScroll: true });
        }, FOCUS_DELAY_MS);
      }

      return;
    }

    // Returning to the primary menu — silently clear any stacked panels.
    allPanels.forEach(panel => {
      if (panel !== currentPanel && panel.classList.contains("is-active")) {
        deactivatePanelInstantly(panel);
      }
    });

    restorePrimaryMenu(primaryMenuPanel);
  };

  /* --------------- *** Forward Navigation *** --------------- */

  const handleForwardNavigation = ({ targetPanel, allPanels, primaryMenuPanel }) => {
    const isNested = targetPanel.hasAttribute("data-menu-nested");

    allPanels.forEach(panel => {
      if (panel.classList.contains("is-active") && !panel.hasAttribute("inert")) {
        panel.setAttribute("inert", "");
      }

      panel.classList.remove("is-back");
    });

    if (primaryMenuPanel) {
      primaryMenuPanel.setAttribute("inert", "");
      primaryMenuPanel.setAttribute("aria-hidden", "true");
    }

    targetPanel.scrollTop = 0;
    targetPanel.classList.add("is-active");
    targetPanel.style.opacity = "1";
    resetMenuPanelScroll(targetPanel);

    if (isNested) {
      targetPanel.classList.add("is-instant");
    }

    const backButton = targetPanel.querySelector("button.menu-header");
    const focusDelay = isNested ? NESTED_TRANSITION_MS : FOCUS_DELAY_MS;

    if (backButton) {
      setTimeout(() => {
        backButton.focus({ preventScroll: true });
      }, focusDelay);
    }

    setTimeout(() => {
      targetPanel.classList.remove("is-instant");
    }, PANEL_TRANSITION_MS);
  };

  /* --------------- *** Menu Panel Click Handlers *** --------------- */

  menuLinks.forEach(menuLink => {
    menuLink.addEventListener("click", () => {
      const targetRef = menuLink.dataset.ref;
      const targetPanel = document.querySelector(
        `div.menu-panel[data-menu="${targetRef}"]`
      );
      const allPanels = document.querySelectorAll(".menu-panel");
      const primaryMenuPanel = document.querySelector(".primary-menu-panel");
      const isBackButton = menuLink.classList.contains("menu-header");
      const currentPanel = menuLink.closest(".menu-panel");

      if (isBackButton) {
        handleBackNavigation({ currentPanel, targetPanel, allPanels, primaryMenuPanel });
        return;
      }

      if (targetPanel) {
        handleForwardNavigation({ targetPanel, allPanels, primaryMenuPanel });
      }
    });
  });

  /* --------------- *** Mobile Menu Escape Key *** --------------- */

  if (mobileDrawerContent) {
    mobileDrawerContent.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;

      const activePanel = mobileDrawerContent.querySelector(
        ".menu-panel.is-active:not([inert])"
      );

      if (!activePanel) return;

      e.preventDefault();
      e.stopPropagation();

      const backButton = activePanel.querySelector("button.menu-header");

      if (!backButton) return;

      backButton.click();

      const previousRef = backButton.dataset.ref;
      const previousPanel = previousRef
        ? mobileDrawerContent.querySelector(`div.menu-panel[data-menu="${previousRef}"]`)
        : null;
      const focusContainer = previousPanel
        || mobileDrawerContent.querySelector(".primary-menu-panel");

      setTimeout(() => {
        const firstFocusable = focusContainer?.querySelector("button, a");
        firstFocusable?.focus();
      }, FOCUS_DELAY_MS);
    });
  }

  var faqPage = document.querySelector('.template--faq');

  if(faqPage) {
    var accordions = document.querySelectorAll(".accordion__section");
    accordions.forEach(function (accordion) {
      accordion.addEventListener("click", function () {
        var headerHeight = document.querySelector(".header").offsetHeight;
        var bodyHeight = this.offsetHeight;
        var accordionTop = accordion.getBoundingClientRect().top;
        var scrollTo = accordionTop - headerHeight - bodyHeight;

        if (scrollTo < 0) {
          scrollTo = 0;
        }
        if (accordionTop > headerHeight) {
          scrollTo = window.scrollY;
        }

        window.scrollTo({
          top: scrollTo,
          behavior: "smooth"
        });
      });
    });
  }
});

/* swiper - hide swiper buttons element if both next and prev buttons are disabled */
document.addEventListener("DOMContentLoaded", function () {
  const allSwiperButtons = document.querySelectorAll(".swiper-buttons");
  allSwiperButtons.forEach(function (swiperButtons) {
    const prevButton = swiperButtons.querySelector("[class^='swiper-button--prev'], [class*=' swiper-button--prev']");
    const nextButton = swiperButtons.querySelector("[class^='swiper-button--next'], [class*=' swiper-button--next']");
    if (prevButton && nextButton && prevButton.classList.contains("swiper-button-disabled") && nextButton.classList.contains("swiper-button-disabled")) {
      swiperButtons.style.display = "none";
    }

    // get grand parent child of swiper-buttons
    const grandParent = swiperButtons.parentElement.parentElement;
    // if grand parent has class of section__foot and this section__foot has no a.button set margin-block-start to 0
    if (grandParent.classList.contains("section__foot") && !grandParent.querySelector("a.button")) {
      grandParent.style.marginBlockStart = "0";
    }
  });
});

/* --------------- *** Product Card *** --------------- */

/**
 * Defers init for off-screen cards via a shared IntersectionObserver.
 * Visible cards (+ 200px margin) init eagerly; the rest init on scroll.
 */
if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    static _observer = null;
    static _hasQuickCartDrawer = null;

    /**
     * Shared observer that triggers init() when a card
     * enters (or is near) the viewport, then unobserves it.
     */
    static _getObserver() {
      if (ProductCard._observer) return ProductCard._observer;

      ProductCard._observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            observer.unobserve(entry.target);
            entry.target.init();
          });
        },
        { rootMargin: "200px" }
      );

      return ProductCard._observer;
    }

    constructor() {
      super();

      this.isQuickCart = this.classList.contains("product-card--quick-cart");

      if (typeof IntersectionObserver !== "undefined") {
        ProductCard._getObserver().observe(this);
      } else {
        this.init();
      }
    }

    init() {
      this.initForm();
      this.initVariants();
      this.imageBorderCalc();

      const hoverableMedia = this.querySelector(".product-card__media--hoverable");

      if (hoverableMedia) {
        this.secondImgHoverStates();
      }

      if (ProductCard._hasQuickCartDrawer === null) {
        ProductCard._hasQuickCartDrawer = !!document.querySelector("quick-cart-drawer");
      }

      if (!ProductCard._hasQuickCartDrawer) {
        this.querySelector(".quick-cart-drawer__trigger")?.remove();
      }
    }

    /**
     * Add to Cart Form
     */
    initForm() {
      /** Variables */
      this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      this.addToCartForm = this.querySelector(
        "form.product-card__add-to-cart--form"
      );
      if (this.addToCartForm) {
        this.addToCartForm.removeAttribute("method");
        this.addToCartForm.removeAttribute("action");
      }
      this.submitButton = this.querySelector('button[type="submit"]');
      /** Event Listeners */
      if (this.addToCartForm && !this.addToCartForm.hasListener) {
        this.submitAddToCartFormHandler = this.submitAddToCartFormHandler || this.submitAddToCartForm.bind(this);
        this.addToCartForm.addEventListener("submit", this.submitAddToCartFormHandler);
        this.addToCartForm.hasListener = true;
      }
    }

    submitAddToCartForm(event) {
      event.preventDefault();

      this.submitButton.setAttribute("disabled", "");
      this.submitButton.classList.add("add-to-cart--is-disabled");

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData(event.target);

      if (this.cart) {
        formData.append(
          "sections",
          this.cart
            .getSectionsToRender()
            .map(section => section.section)
        );
        if (this.hasAttribute('data-has-pre-order')) {
          formData.append('properties[Pre-order]', '✓');
        }
        formData.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.errors) {
            this.handleErrorMessage(response.errors);
            return;
          }

          if (this.cart) {
            this.cart.renderContents(response);
          }

          updateCartCounters();
        })
        .catch((error) => { console.error(error) })
        .finally(() => {
          this.submitButton.removeAttribute("disabled");
          this.submitButton.classList.remove(
            "add-to-cart--is-disabled"
          );

          const quickCartDrawer = this.closest("quick-cart-drawer");
          if (quickCartDrawer) {
            quickCartDrawer.close();
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.querySelector(
        ".product-form__error-message-wrapper"
      );
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessageWrapper.querySelector(
        ".product-form__error-message"
      );

      this.errorMessageWrapper.toggleAttribute(
        "hidden",
        !errorMessage
      );

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }

      setTimeout(() => {
        this.resetErrorMessage();
      }, 5000);
    }

    resetErrorMessage() {
      if (!this.errorMessageWrapper) return;
      this.errorMessageWrapper.toggleAttribute("hidden", true);
      this.errorMessageWrapper.textContent = "";
    }

    /**
     * Product Variants
     */
    initVariants() {
      if (this._variantsInitialized) return;
      this._variantsInitialized = true;

      this.getVariantsData();

      // event listeners for variant buttons
      this.querySelectorAll(".button--variant input").forEach(
        variantButton => {
          variantButton.addEventListener(
            "click",
            this.onClickOptionRadioInputs.bind(this)
          );
        }
      );

      // set initial checked options
      let initialCheckedOptions = [];
      this.querySelectorAll(".variant-option-radio-input").forEach(
        radioInput => {
          if (radioInput.checked) {
            initialCheckedOptions.push(radioInput.value);
          }
        }
      );

      // ensure at least one option is selected on load
      if (initialCheckedOptions.length === 0) {
        this.querySelector(".variant-option-radio-input")?.click();
      }

      // immediately update variant statuses to set disabled states on load
      this.updateVariantStatuses();

      const { currentVariantId } = this.findCurrentVariantFromOptionRadioInputs();

      // update media and cart button states
      if (!this.querySelector(".product-card__media")?.dataset.updateMedia) {
        this.updateMediaForVariant(currentVariantId);
      }
      this.setCartButtonState();
    }

    updateVariantStatuses() {

      const selectedOptionOneVariants = this.variantsObj?.filter(
        variant =>
          this.querySelector(":checked")?.value === variant.option1
      );

      const inputWrappers = [
        ...this.querySelectorAll(".js-product-card-options")
      ];

      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [
          ...option.querySelectorAll('input[type="radio"]')
        ];
        const previousOptionSelected =
          inputWrappers[index - 1].querySelector(":checked")?.value;
        const availableOptionInputsValue = selectedOptionOneVariants
          ?.filter(
            variant =>
              variant.available &&
              variant[`option${index}`] === previousOptionSelected
          )
          .map(variantOption => variantOption[`option${index + 1}`]);

        this.setInputAvailability(
          optionInputs,
          availableOptionInputsValue
        );
      });
    }

    setInputAvailability(elementList, availableValuesList) {
      elementList.forEach(element => {
        const value = element.getAttribute("value");
        const availableElement = availableValuesList.includes(value);
        const wrapper = element.closest("li") || element.closest(".button--variant");

        if (wrapper) {
          wrapper.classList.toggle("disabled", !availableElement);
        }

        element.toggleAttribute("disabled", !availableElement);
      });
    }

    onClickOptionRadioInputs(event) {
      const {
        currentVariantId,
        currentCheckedOptions,
        currentVariantMediaId
      } = this.findCurrentVariantFromOptionRadioInputs();

      this.clearRadioInputStates(event);

      if (currentCheckedOptions.includes(event.target.value)) {
        // console.log('event.target', event.target);
        event.target.setAttribute("checked", "");
        // event.target.closest("div").classList.add("checked");

        this.updateVariantStatuses();

        this.disableAddToCartButons();

        // call to update price when variant is changed
        this.updatePriceForVariant(currentVariantId);

        // call to update discount badge when variant is changed
        this.updateDiscountBadgeForVariant(currentVariantId);
      }

      // update form input variant-id
      this.updateFormVariantIdInput();

      // update product image shown
      let allVariantIdsWithImageAvailable = [];
      this.querySelectorAll("[data-product-images]").forEach(el => {
        el.getAttribute("data-product-images")
          .split(",")
          .forEach(v => {
            allVariantIdsWithImageAvailable.push(v);
          });
      });
      if (allVariantIdsWithImageAvailable.includes(currentVariantId.toString())) {
        this.updateMediaForVariant(currentVariantId);
      }

      if (this.isQuickCart && currentVariantMediaId) {
        document
          .querySelector("quick-cart-drawer")
          .setActiveMedia(currentVariantMediaId);
      }

      // update product link
      this.querySelectorAll("[data-product-link]").forEach(
        linkItem => {
          const currentLink = linkItem.getAttribute("href");
          if (currentVariantId) {
            const newLink =
              currentLink.split("?variant=")[0] +
              "?variant=" +
              currentVariantId;
            linkItem.setAttribute("href", newLink);
          }
        }
      );
    }

    setCartButtonState() {
      const { currentVariantAvailable } = this.findCurrentVariantFromOptionRadioInputs();
      if (!currentVariantAvailable) return;
      this.submitButton?.toggleAttribute(
        "disabled",
        !currentVariantAvailable
      );
    }

    updateMediaForVariant(currentVariantId) {
      if (!currentVariantId) return;
      this.querySelectorAll("[data-product-images]").forEach(el => {
        el.classList.toggle(
          "hidden",
          !el
            .getAttribute("data-product-images")
            .includes(currentVariantId)
        );
      });
    }

    updateFormVariantIdInput() {
      const { currentVariantId } = this.findCurrentVariantFromOptionRadioInputs();
      const input = this.querySelector('input[name="id"]');

      if (currentVariantId && input) {
        input.value = currentVariantId;
      }

      if (this.isQuickCart && currentVariantId) {
        const quickCartDrawer = this.closest('quick-cart-drawer');
        const formInput = quickCartDrawer?.querySelector('.product-card__add-to-cart--form input[name="id"]');

        if (formInput) {
          formInput.value = currentVariantId;
        }
      }
    }

    updatePriceForVariant(variantId) {
      // Assuming the variantsObj contains the variant data, including price
      const selectedVariant = this.variantsObj?.find(
        variant => variant.id === variantId
      );

      if (selectedVariant) {
        let priceContainer = this.querySelector(".price__container");
        // if priceContainer does not exist, check previous element
        if (!priceContainer) {
          const previousElement = this.previousElementSibling;
          if (previousElement) {
            // check if previous element has class of price__container
            priceContainer = previousElement.querySelector(
              ".price__container"
            );
          }
        }

        if (!priceContainer) return;
        const moneyFormat = priceContainer.dataset.moneyFormat;
        const labelPriceRegular = priceContainer.dataset.labelPriceRegular;
        const labelPriceSale = priceContainer.dataset.labelPriceSale;

        if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
          const discountPct = Math.round(((selectedVariant.compare_at_price - selectedVariant.price) / selectedVariant.compare_at_price) * 100);

          const priceHtml = `
            <div class="price__sale">
              <div class="price__sale-inner">
                <span class="visually-hidden">${labelPriceSale}</span>
                <s>${formatPrice(selectedVariant.compare_at_price, moneyFormat)}</s>
                <ins>
                  <span class="visually-hidden">${labelPriceRegular}</span>
                  ${formatPrice(selectedVariant.price, moneyFormat)}
                </ins>
              </div>
              <span class="price__discount">${discountPct}% Off</span>
            </div>
          `;
          priceContainer.innerHTML = priceHtml;
        } else {
          // generate html block and append to price container
          const priceHtml = `
            <div class="price__sale">
              <div class="price__sale-inner">
                <span class="visually-hidden">${labelPriceRegular}</span>
                <span>${formatPrice(selectedVariant.price, moneyFormat)}</span>
              </div>
            </div>
          `;
          priceContainer.innerHTML = priceHtml;
        }
      }
    }

    updateDiscountBadgeForVariant(variantId) {
      const selectedVariant = this.variantsObj?.find(
        variant => variant.id === variantId
      );
      if (selectedVariant) {
        let discountBadge = this.querySelector(
          ".product-card__badge--discount"
        );
        // if discountBadge does not exist, check previous element
        if (!discountBadge) {
          const previousElement = this.previousElementSibling;
          if (previousElement) {
            // check if previous element has class of product-card__badge--discount
            discountBadge = previousElement.querySelector(
              ".product-card__badge--discount"
            );
          }
        }

        if (discountBadge) {
          if (
            selectedVariant.compare_at_price > selectedVariant.price
          ) {
            discountBadge.classList.remove("hidden");
            const percentageElement =
              discountBadge.querySelector(".percentage");

            if (!percentageElement) return;
            // calculate discount percentage
            const discountPercentage = Math.round(
              ((selectedVariant.compare_at_price -
                selectedVariant.price) /
                selectedVariant.compare_at_price) *
                100
            );
            // update discount percentage
            percentageElement.textContent = discountPercentage;
          } else {
            discountBadge.classList.add("hidden");
          }
        }
      }
    }

    disableCheckedVariantOptions() {
      this.querySelectorAll(
        ".variant-option-radio-input[checked]"
      ).forEach(variantBtn => {
        if (this.isQuickCart) {
          variantBtn.setAttribute("disabled", "");
          // variantBtn.closest("div").classList.add("disabled");
        } else {
          variantBtn.removeAttribute("disabled");
        }
      });
    }

    disableAddToCartButons() {
      const { currentVariantAvailable } =
        this.findCurrentVariantFromOptionRadioInputs();
      const submitBtn = this.querySelector(
        ".product-card__add-to-cart--form button[type='submit']"
      );

      if (
        submitBtn &&
        !submitBtn.classList.contains(
          "product-card__add-to-cart--button"
        )
      ) {
        if (!currentVariantAvailable) {
          submitBtn.setAttribute("disabled", "");
        } else {
          submitBtn.removeAttribute("disabled");
        }
      }
    }

    clearRadioInputStates(event) {
      event.target
        .closest(".js-product-card-options")
        .querySelectorAll(".variant-option-radio-input")
        .forEach(radioInput => {
          radioInput.removeAttribute("checked");
        });
    }

    findCurrentVariantFromOptionRadioInputs() {
      let currentVariantAvailable = null;
      let currentVariantId = "";
      let currentVariantMediaId = "";
      let currentCheckedOptions = [];

      this.querySelectorAll(".js-product-card-options").forEach(
        item => {
          if (!item.parentNode.classList.contains("hidden")) {
            item
              .querySelectorAll('input[type="radio"]')
              .forEach(radioInput => {
                if (radioInput.checked) {
                  currentCheckedOptions.push(radioInput.value);
                }
              });
          } else {
            // hidden variant (size or etc) always uses the first option
            currentCheckedOptions.push(
              item.querySelector('input[type="radio"]').value
            );
          }
        }
      );

      this.variantsObj?.forEach(item => {
        if (
          item.options.join() === currentCheckedOptions.join() ||
          (item.options.length === 1 &&
            currentCheckedOptions.length === 0)
        ) {
          currentVariantId = item.id;
          currentVariantAvailable = item.available;
          currentVariantMediaId = item.featured_media?.id || null;
        }
      });

      return {
        currentVariantAvailable,
        currentVariantId,
        currentCheckedOptions,
        currentVariantMediaId
      };
    }

    findAndDisableAllUnavailableOptionsForSelectedVariant(
      selectedOption
    ) {
      let selectedOptionName = "";
      if (selectedOption) {
        selectedOptionName = selectedOption.value;
      } else {
        selectedOptionName = this.querySelectorAll(
          ".variant-option-radio-input"
        )[0].value;
      }

      const { currentCheckedOptions } =
        this.findCurrentVariantFromOptionRadioInputs();
      const optionIndex =
        currentCheckedOptions.indexOf(selectedOptionName) + 1;

      this.variantsObj.forEach(item => {
        if (
          item[`option${optionIndex}`] === selectedOptionName &&
          !item.available
        ) {
          [1, 2, 3].forEach(i => {
            if (i !== optionIndex && item[`option${i}`]) {
              const itemToDisable = this.querySelector(
                `.variant-option-radio-input[value="${
                  item[`option${i}`]
                }"]`
              );
              // itemToDisable.setAttribute("disabled", "");
              itemToDisable.closest("li").classList.add("disabled");
            }
          });
        }
      });
    }

    getVariantsData() {
      const variantsObj = JSON.parse(
        this.querySelector("[data-product-variants-json]")
          ? this.querySelector("[data-product-variants-json]")
              .textContent
          : "[]"
      );
      if (variantsObj && Object.keys(variantsObj).length === 0)
        return false;
      this.variantsObj = variantsObj;
      return variantsObj;
    }

    /** Additional event listerner for styling on hovering mutliple nested items */
    secondImgHoverStates() {
      const hoverableItem = this.querySelector(
        ".product-card__actions"
      );

      if (!hoverableItem || DeviceDetector.isMobile()) {
        return;
      }

      hoverableItem.addEventListener("mouseenter", () =>
        hoverableItem.classList.add("is--hovering")
      );
      hoverableItem.addEventListener("mouseleave", () =>
        hoverableItem.classList.remove("is--hovering")
      );
    }

    imageBorderCalc() {
      const images = this.querySelectorAll(".product-swatch__inner-border--enable img");

      if(images) {
        images.forEach((image) => {
          if (image.complete) {
            processImage(image);
          } else {
            image.onload = () => processImage(image);
          }
        });
      }

      function processImage(image) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const width = image.naturalWidth || image.width;
        const height = image.naturalHeight || image.height;

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(image, 0, 0, width, height);

        const centerX = Math.floor(width / 2);
        const centerY = Math.floor(height / 2);

        const pixelData = ctx.getImageData(centerX, centerY, 1, 1).data;
        const r = pixelData[0];
        const g = pixelData[1];
        const b = pixelData[2];

        const darkenFactor = 0.8;
        const darkenedR = Math.max(0, Math.floor(r * darkenFactor));
        const darkenedG = Math.max(0, Math.floor(g * darkenFactor));
        const darkenedB = Math.max(0, Math.floor(b * darkenFactor));
        const darkenedColor = `rgb(${darkenedR}, ${darkenedG}, ${darkenedB})`;

        image.style.borderColor = darkenedColor;
      }
    }

  }
  customElements.define("product-card", ProductCard);
}

async function updateCartCounters() {
  const headerCartCounters = document.querySelectorAll('.cart-count-badge');
  const drawerCartCounters = document.querySelectorAll('.cart-drawer__title-counter');

  // combine both counters and filter out any null elements
  const cartCounters = [...headerCartCounters, ...drawerCartCounters].filter(counter => counter !== null);

  try {
    const response = await fetch(`${routes.cart_url}.json`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });

    const state = await response.text();
    const parsedState = JSON.parse(state);

    if (cartCounters.length > 0) {
      // update all cart counters with the current item count
      cartCounters.forEach(counter => {
        counter.textContent = parsedState.item_count;
      });
    }

    // toggle 'hidden' class on header counters based on the item count
    if (headerCartCounters.length > 0) {
      headerCartCounters.forEach(counter => {
        counter.classList.toggle("hidden", parsedState.item_count === 0);
      });
    }
  } catch (error) {
    console.error("Cart counters could not be updated:", error);
  }
}

async function updateFreeShipping() {
  const conversionRate = Shopify.currency.rate;
  const {
    cart_free_shipping_text: freeShippingTextDefault,
    cart_free_shipping_text_success: freeShippingTextSuccessDefault,
    cart_free_shipping_threshold: freeShippingThreshold,
    money_format: moneyFormat
  } = window.theme.settings;

  const freeShippingElements = document.querySelectorAll("shipping-bar");

  try {
    const response = await fetch("/cart.js");
    const { total_price, item_count } = await response.json();

    const visibility = item_count == 0 ? "hidden" : "visible";
    freeShippingElements.forEach(
      el => (el.style.visibility = visibility)
    );

    const newShippingThreshold = Math.round(freeShippingThreshold * conversionRate);
    const newRemainingAmount = newShippingThreshold - total_price;

    freeShippingElements.forEach(freeShipping => {
      const freeShippingTextElement = freeShipping.querySelector(".progress-bar__text");
      const progressBarInner = freeShipping.querySelector("[data-progress-line]");
      if (total_price >= newShippingThreshold) {
        freeShippingTextElement.innerHTML = freeShippingTextSuccessDefault;
        progressBarInner.style.width = "100%";
      } else {
        const moneyMatch = freeShippingTextDefault.match(/<span class="money">(.*)<\/span>/);
        if (moneyMatch) {
          const newFreeShippingText = freeShippingTextDefault.replace(
            moneyMatch[1],
            `${formatPrice(newRemainingAmount, moneyFormat)}`
          );
          freeShippingTextElement.innerHTML = newFreeShippingText;
        }
        progressBarInner.style.width = `calc(${(total_price / newShippingThreshold) * 100}% + 2px)`;
      }
    });
  } catch (error) {
    console.error("Error fetching cart data:", error);
  }
}

function formatPrice(amount, moneyString) {
  if (amount !== null && amount !== undefined) {
    amount = parseFloat(amount) / 100;
  } else {
    return ''; // If data is missing, return empty string
  }

  const money_format = /{{(.*?)}}/;

  let money_format_option = "";
  if (moneyString.match(money_format)) {
    money_format_option = moneyString.match(money_format)[1];
  } else {
    console.error("No match found");
  }

  let newValue = "";
  switch (money_format_option) {
    case "amount":
      newValue = moneyString.replace(
        money_format,
        Intl.NumberFormat(Shopify.locale, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount)
      );
      break;
    case "amount_with_comma_separator":
      newValue = moneyString.replace(
        money_format,
        amount.toString().replace(".", ",")
      );
      break;
    case "amount_no_decimals":
      newValue = moneyString.replace(
        money_format,
        Math.round(amount)
      );
      break;
    case "amount_no_decimals_with_comma_separator":
      newValue = moneyString.replace(
        money_format,
        Intl.NumberFormat(Shopify.locale)
          .format(Math.round(amount))
          .toString()
          .replace(".", ",")
      );
      break;
    default:
      newValue = moneyString.replace(money_format, amount);
      break;
  }

  return newValue;
}

class SwiperComponent extends HTMLElement {
  constructor() {
    super();
    this.swiperOptions = JSON.parse(this.getAttribute("data-swiper-options")) || {};
    this.swiperInitialized = false;

    this.section = this.closest("section");
  }

  connectedCallback() {
    const inShopifySection =
      this.section && this.section.classList.contains("shopify-section");

    if (inShopifySection) {
      this.scheduleInit();
    }

    if (Shopify.designMode) {
      window.addEventListener("shopify:section:load", () => this.scheduleInit());
      window.addEventListener("shopify:section:select", () => this.scheduleInit());

      setTimeout(() => {
        if (!this.swiperInitialized) this.scheduleInit();
      }, 100);
    } else if (!inShopifySection) {
      window.addEventListener("load", () => this.scheduleInit());
    }
  }

  scheduleInit() {
    if (this.swiperInitialized) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.init();
      });
    });
  }

  init() {
    if (this.swiperInitialized) return; // prevent multiple initializations
    this.swiperInitialized = true;

    const swiperOptions = this.swiperOptions;

    const themeSwiper = window.themeSwiper;
    const useSwiperMutationObserver = themeSwiper
      ? themeSwiper.shouldObserveSlideMutations(swiperOptions.swiperName)
      : true;

    const option = {
      slideshowId: swiperOptions.swiperId || "",
      slideCount: swiperOptions.slideCount || 1,
      slidesPerView: swiperOptions.slidesPerView || "auto",
      slidesPerViewDesktop:
        swiperOptions.slidesPerViewDesktop ||
        swiperOptions.slidesPerView ||
        4,
      slidesPerViewTablet:
        swiperOptions.slidesPerViewTablet ||
        swiperOptions.slidesPerViewDesktop ||
        swiperOptions.slidesPerView ||
        3,
      spaceBetween: swiperOptions.spaceBetweenMobile || 0,
      spaceBetweenDesktop:
        swiperOptions.spaceBetweenDesktop ||
        swiperOptions.spaceBetween ||
        0,
      spaceBetweenTablet:
        swiperOptions.spaceBetweenTablet ||
        swiperOptions.spaceBetweenDesktop ||
        swiperOptions.spaceBetweenMobile ||
        0,
      enabled: swiperOptions.enabled ?? true,
      enabledDesktop:
        swiperOptions.enabledDesktop ?? swiperOptions.enabled ?? true,
      enabledTablet:
        swiperOptions.enabledTablet ??
        swiperOptions.enabledDesktop ??
        swiperOptions.enabled ??
        true,
      allowTouchMove:
        swiperOptions.allowTouchMove ??
        (typeof swiperOptions.slidesPerView === "number"
          ? swiperOptions.slideCount > swiperOptions.slidesPerView
            ? true
            : false
          : true),
      allowTouchMoveTablet:
        swiperOptions.allowTouchMoveTablet ??
        (typeof swiperOptions.slidesPerViewTablet === "number"
          ? swiperOptions.slideCount > swiperOptions.slidesPerViewTablet
            ? true
            : false
          : true),
      allowTouchMoveDesktop:
        swiperOptions.allowTouchMoveDesktop ??
        (typeof swiperOptions.slidesPerViewDesktop === "number"
          ? swiperOptions.slideCount > swiperOptions.slidesPerViewDesktop
            ? true
            : false
          : true)
    };

    const cssModeEnabled =
      swiperOptions.cssMode === true || swiperOptions.cssMode === "true";

    this.swiperOptions = {
      a11y: false,
      allowTouchMove: option.allowTouchMove,
      loop: swiperOptions.loop || false,
      rewind: swiperOptions.rewind || false,
      followFinger: swiperOptions.followFinger || false,
      cssMode: cssModeEnabled,
      enabled: option.enabled,
      watchOverflow: true,
      observer: useSwiperMutationObserver,
      cache: true,
      slidesPerView: option.slidesPerView,
      spaceBetween: option.spaceBetween,
      breakpoints: {
        750: {
          enabled: option.enabledTablet,
          allowTouchMove: option.allowTouchMoveTablet,
          slidesPerView: option.slidesPerViewTablet,
          spaceBetween: option.spaceBetweenTablet
        },
        1200: {
          enabled: option.enabledDesktop,
          allowTouchMove: option.allowTouchMoveDesktop,
          slidesPerView: option.slidesPerViewDesktop,
          spaceBetween: option.spaceBetweenDesktop
        }
      }
    };

    if (swiperOptions.navigation) {
      this.swiperOptions.navigation = {
        ...swiperOptions.navigation
      };
    }

    if (swiperOptions.effect == "fade") {
      this.swiperOptions.effect = "fade";
      this.swiperOptions.fadeEffect = {
        crossFade: true
      };
    }

    if (swiperOptions.pagination == "custom_bullet") {
      this.swiperOptions.pagination = {
        el: swiperOptions.paginationElement,
        clickable: true,
        renderBullet: function (i, className) {
          return `
            <button class="${className}">
              <span></span>
            </button>
          `;
        }
      };
    } else {
      const paginationEl = this.querySelector(
        `.swiper-pagination--${swiperOptions.swiperId}`
      );

      if (paginationEl) {
        this.swiperOptions.pagination = {
          el: paginationEl,
          clickable: true
        };
      } else {
        this.swiperOptions.pagination = false;
      }
    }

    if (swiperOptions.autoplay) {
      this.swiperOptions.autoplay = {
        ...swiperOptions.autoplay
      };

      if (swiperOptions.autoplayProgress) {
        const progressCircle = this.querySelector(
          `.autoplay-progress--${swiperOptions.swiperId} svg`
        );
        const progressContent = this.querySelector(
          `.autoplay-progress--${swiperOptions.swiperId} span`
        );

        this.swiperOptions.on = {
          autoplayTimeLeft(s, time, progress) {
            progressCircle.style.setProperty("--progress", 1 - progress);
            progressContent.textContent = `${Math.ceil(time / 1000)}`;
          },
        };
      }
    }

    this.swiper = new Swiper(this, {
      ...this.swiperOptions
      // on: {
      //   init: () => {
      //     setTimeout(() => {
      //       if (this.section) {
      //         this.section.classList.remove(this.hiddenClass);
      //       }
      //     }, 100);
      //   }
      // }
    });

    window.themeSwiper?.notifyLayoutChange?.();
  }
}
customElements.define("swiper-component", SwiperComponent);


class ModalDialogAlt extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    if (popup) popup.loadContent();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog-alt', ModalDialogAlt);

class ModalOpenerAlt extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener-alt', ModalOpenerAlt);

/* --------------- *** Product group keyboard (radio-style roving) *** --------------- */

const PRODUCT_GROUP_FOCUSABLE_SELECTOR =
  '.product-option__label > a.product-option__link, .product-option__label > button.product-option__link';

const PRODUCT_GROUP_NAV_KEYS = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];

/**
 * One tab stop per product-metaobject group; Arrow/Home/End move focus like variant radios.
 */
const initProductGroupKeyboardNav = (fieldset) => {
  if (!(fieldset instanceof HTMLFieldSetElement)) {
    return;
  }

  if (fieldset._productGroupKeyboardAbort) {
    fieldset._productGroupKeyboardAbort.abort();
    fieldset._productGroupKeyboardAbort = null;
  }

  const getFocusables = () =>
    Array.from(fieldset.querySelectorAll(PRODUCT_GROUP_FOCUSABLE_SELECTOR)).filter(
      (el) => !(el instanceof HTMLButtonElement && el.disabled)
    );

  const focusables = getFocusables();

  if (focusables.length < 2) {
    return;
  }

  const setRovingTabindex = (items, activeIndex) => {
    items.forEach((el, i) => {
      el.setAttribute('tabindex', i === activeIndex ? '0' : '-1');
    });
  };

  const defaultActiveIndex = (items) => {
    const activeLabel = fieldset.querySelector('.product-option__label.active');
    const activeEl = activeLabel?.querySelector(
      'a.product-option__link, button.product-option__link'
    );

    if (activeEl) {
      const idx = items.indexOf(activeEl);

      if (idx >= 0) {
        return idx;
      }
    }

    return 0;
  };

  let items = focusables;
  let activeIndex = defaultActiveIndex(items);

  setRovingTabindex(items, activeIndex);

  const ac = new AbortController();
  fieldset._productGroupKeyboardAbort = ac;

  const handleFocusin = (event) => {
    const target = event.target;

    if (!(target instanceof HTMLAnchorElement) && !(target instanceof HTMLButtonElement)) {
      return;
    }

    const nextItems = getFocusables();

    if (nextItems.length < 2) {
      return;
    }

    items = nextItems;
    const idx = items.indexOf(target);

    if (idx === -1) {
      return;
    }

    activeIndex = idx;
    setRovingTabindex(items, activeIndex);
  };

  const handleKeydown = (event) => {
    const target = event.target;

    if (!(target instanceof HTMLAnchorElement) && !(target instanceof HTMLButtonElement)) {
      return;
    }

    if (!PRODUCT_GROUP_NAV_KEYS.includes(event.key)) {
      return;
    }

    items = getFocusables();

    if (items.length < 2) {
      return;
    }

    const start = items.indexOf(target);

    if (start === -1) {
      return;
    }

    event.preventDefault();

    const len = items.length;
    const isRtl = document.documentElement.getAttribute('dir') === 'rtl';
    let next = start;

    if (event.key === 'Home') {
      next = 0;
    } else if (event.key === 'End') {
      next = len - 1;
    } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      next = isRtl ? (start - 1 + len) % len : (start + 1) % len;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      next = isRtl ? (start + 1) % len : (start - 1 + len) % len;
    }

    activeIndex = next;
    setRovingTabindex(items, activeIndex);
    items[next].focus();
  };

  fieldset.addEventListener('focusin', handleFocusin, { signal: ac.signal });
  fieldset.addEventListener('keydown', handleKeydown, { signal: ac.signal });
};

const initAllProductGroupKeyboardNav = (root = document) => {
  const scope = root instanceof Document || !root ? document : root;

  scope.querySelectorAll('fieldset.product__product-group').forEach((fieldset) => {
    initProductGroupKeyboardNav(fieldset);
  });
};

window.initAllProductGroupKeyboardNav = initAllProductGroupKeyboardNav;

document.addEventListener('DOMContentLoaded', () => {
  initAllProductGroupKeyboardNav();
});

document.addEventListener(
  'opened',
  (event) => {
    if (event.target?.matches?.('quick-cart-drawer')) {
      initAllProductGroupKeyboardNav(event.target);
    }
  },
  true
);

if (Shopify.designMode) {
  window.addEventListener('shopify:section:load', () => {
    initAllProductGroupKeyboardNav();
  });
}

class DeferredMediaAlt extends HTMLElement {
  constructor() {
    super();
    this.onViewportResize = this.handleViewportResize.bind(this);
    this.resizeRaf = null;

    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (poster) {
      poster.addEventListener('click', this.loadContent.bind(this));
    }
  }

  connectedCallback() {
    window.addEventListener('resize', this.onViewportResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onViewportResize);
    if (this.resizeRaf) {
      window.cancelAnimationFrame(this.resizeRaf);
      this.resizeRaf = null;
    }
  }

  getResponsiveTemplateData() {
    const template = this.querySelector('template');
    if (!template) return null;

    const desktopSource = template.content.querySelector('.modal-video__source--desktop');
    const tabletSource = template.content.querySelector('.modal-video__source--tablet');
    const mobileSource = template.content.querySelector('.modal-video__source--mobile');
    const hasResponsiveSources = Boolean(desktopSource || tabletSource || mobileSource);
    const isTabletViewport = window.matchMedia('(min-width: 750px) and (max-width: 989px)').matches;
    const isMobileViewport = window.matchMedia('(max-width: 749px)').matches;

    let targetVariant = 'desktop';
    if (isMobileViewport && mobileSource) {
      targetVariant = 'mobile';
    } else if (isTabletViewport && tabletSource) {
      targetVariant = 'tablet';
    }

    return {
      template,
      desktopSource,
      tabletSource,
      mobileSource,
      hasResponsiveSources,
      targetVariant,
    };
  }

  getMediaElementFromTemplate(templateData) {
    if (!templateData || !templateData.template) return null;

    if (templateData.hasResponsiveSources) {
      const sourceContainer =
        templateData.targetVariant === 'mobile'
          ? templateData.mobileSource
          : templateData.targetVariant === 'tablet'
            ? templateData.tabletSource
            : templateData.desktopSource;
      if (sourceContainer && sourceContainer.firstElementChild) {
        return sourceContainer.firstElementChild.cloneNode(true);
      }
    }

    const templateFirstElement = templateData.template.content.firstElementChild;
    return templateFirstElement ? templateFirstElement.cloneNode(true) : null;
  }

  handleViewportResize() {
    if (this.resizeRaf) return;
    this.resizeRaf = window.requestAnimationFrame(() => {
      this.resizeRaf = null;
      this.reloadForViewportIfNeeded();
    });
  }

  reloadForViewportIfNeeded() {
    if (!this.getAttribute('loaded') || !this.isModalOpen()) return;

    const templateData = this.getResponsiveTemplateData();
    if (!templateData?.hasResponsiveSources) return;
    if (this.dataset.loadedVariant === templateData.targetVariant) return;

    this.loadContent(false);
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    const templateData = this.getResponsiveTemplateData();
    const loadedVariant = this.dataset.loadedVariant;
    const shouldReloadForVariantChange =
      templateData?.hasResponsiveSources && this.getAttribute('loaded') && loadedVariant !== templateData.targetVariant;

    if (!this.getAttribute('loaded') || shouldReloadForVariantChange) {
      if (shouldReloadForVariantChange) {
        this.querySelector('video, model-viewer, iframe')?.remove();
        this.removeAttribute('loaded');
      }

      const mediaElement = this.getMediaElementFromTemplate(templateData);
      if (!mediaElement) return;

      this.setAttribute('loaded', true);
      if (templateData?.hasResponsiveSources) {
        this.dataset.loadedVariant = templateData.targetVariant;
      }

      const deferredElement = this.appendChild(mediaElement);
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Add video event listeners after content is loaded
      this.attachVideoEventListeners(deferredElement);
    } else {
      // If already loaded, auto-play if it's in a modal (currentTime already reset when video ended)
      const videoElement = this.querySelector('video');
      if (videoElement && this.isModalOpen()) {
        // Auto-play when modal reopens
        videoElement.play().catch(e => {
          // console.log('Auto-play failed:', e);
        });
      }
    }
  }

  attachVideoEventListeners(deferredElement) {
    if (deferredElement && deferredElement.nodeName === 'VIDEO') {
      const video = deferredElement;

      // Avoid duplicate event listeners
      if (video.dataset.eventsAttached) return;
      video.dataset.eventsAttached = 'true';

      // Auto-close modal when video ends (only if not looping)
      video.addEventListener('ended', () => {
        // console.log('Video ended event fired');
        const isLooping = video.hasAttribute('loop') || video.loop;
        // console.log('Is looping?', isLooping, 'Is in modal?', this.isInModal());

        if (!isLooping && this.isInModal()) {
          // Reset video time before closing modal to prevent flicker on reopen
          video.currentTime = 0;
          // console.log('Auto-closing modal...');
          this.closeModal();
        }
      });

      // Debug event listeners
      video.addEventListener('play', () => {
        // console.log('Video started playing');
      });

      video.addEventListener('pause', () => {
        // console.log('Video paused');
      });
    }
  }

  isInModal() {
    return this.closest('modal-dialog') !== null;
  }

  isModalOpen() {
    const modal = this.closest('modal-dialog');
    return Boolean(modal && modal.hasAttribute('open'));
  }

  closeModal() {
    const modal = this.closest('modal-dialog');
    if (modal && typeof modal.hide === 'function') {
      modal.hide();
    }
  }
}

customElements.define('deferred-media-alt', DeferredMediaAlt);


// --------------- *** Size Guide *** ---------------

class SizeGuide extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleTabKeydown = this.handleTabKeydown.bind(this);
  }

  connectedCallback() {
    this.tabButtons = Array.from(this.querySelectorAll('[data-size-guide-tab]'));
    this.tabPanels = Array.from(this.querySelectorAll('[data-size-guide-panel]'));
    this.unitButtons = Array.from(this.querySelectorAll('[data-size-guide-unit]'));
    this.unitContents = Array.from(this.querySelectorAll('[data-size-guide-content]'));

    if (this.tabButtons.length && this.tabPanels.length) {
      const defaultTab = (this.dataset.defaultSizeGuideTab || 'chart').toLowerCase();
      this.setActiveTab(defaultTab);
      this.addEventListener('keydown', this.handleTabKeydown);
    }

    if (this.unitButtons.length && this.unitContents.length) {
      const defaultUnit = (this.dataset.defaultSizeGuideUnit || 'in').toLowerCase();
      this.setActiveUnit(defaultUnit);
    }

    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleTabKeydown);
  }

  handleClick(event) {
    const tabButton = event.target.closest('[data-size-guide-tab]');
    if (tabButton && this.contains(tabButton)) {
      event.preventDefault();
      this.setActiveTab(tabButton.dataset.sizeGuideTab);
      return;
    }

    const button = event.target.closest('[data-size-guide-unit]');
    if (!button || !this.contains(button)) return;

    event.preventDefault();
    this.setActiveUnit(button.dataset.sizeGuideUnit);
  }

  handleTabKeydown(event) {
    const currentTab = event.target.closest('[data-size-guide-tab]');
    if (!currentTab || !this.contains(currentTab)) return;

    const tabCount = this.tabButtons.length;
    if (!tabCount) return;

    const currentIndex = this.tabButtons.indexOf(currentTab);
    let nextIndex = -1;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        nextIndex = (currentIndex + 1) % tabCount;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        nextIndex = (currentIndex - 1 + tabCount) % tabCount;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = tabCount - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    const nextTab = this.tabButtons[nextIndex];
    this.setActiveTab(nextTab.dataset.sizeGuideTab, { focus: true });
  }

  setActiveTab(tab, options = {}) {
    const { focus = false } = options;
    const requestedTab = (tab || '').toLowerCase();
    if (!requestedTab) return;

    const hasRequestedTab = this.tabButtons.some((button) => button.dataset.sizeGuideTab === requestedTab);
    const activeTab = hasRequestedTab ? requestedTab : this.tabButtons[0]?.dataset.sizeGuideTab;
    if (!activeTab) return;

    this.tabButtons.forEach((button) => {
      const isActive = button.dataset.sizeGuideTab === activeTab;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', `${isActive}`);
      button.setAttribute('tabindex', isActive ? '0' : '-1');

      if (isActive && focus) {
        button.focus();
      }
    });

    this.tabPanels.forEach((panel) => {
      const isActive = panel.dataset.sizeGuidePanel === activeTab;
      panel.hidden = !isActive;
      panel.setAttribute('aria-hidden', `${!isActive}`);
    });
  }

  setActiveUnit(unit) {
    const activeUnit = (unit || '').toLowerCase();
    if (!activeUnit) return;

    this.unitButtons.forEach((button) => {
      const isActive = button.dataset.sizeGuideUnit === activeUnit;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', `${isActive}`);
    });

    this.unitContents.forEach((content) => {
      const isActive = content.dataset.sizeGuideContent === activeUnit;
      content.hidden = !isActive;
      content.setAttribute('aria-hidden', `${!isActive}`);
    });
  }
}
if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide);
}
